//STKICC_PC_01
import React, { Component } from 'react';
import * as CookieService from '../CookieService';
import * as $ from 'jquery';
import SDIConstants from '../SDIConstants';
import { withTranslation, Trans } from 'react-i18next'
import PDFPreviewComponent from './PDFPreviewComponent';
import Autocomplete from 'react-autocomplete';
import Select from 'react-select';
import * as STKIssuesCartAction from '../actions/STKIssuesCartAction';
import STKIssuesCartStore from '../stores/STKIssuesCartStore';
import Image from 'react-image-resizer';
import * as MenuAction from '../actions/MenuAction';
import { breakpoints } from '@material-ui/system';
import QrReader from 'react-qr-scanner';
//import { QrReader } from 'react-qr-reader';
//import reader from 'html5-qrcode';
//import { QRScaner, Camera } from "react-qrcode-scan";
import BarcodeScannerComponent from "react-qr-barcode-scanner";
import swal from 'sweetalert';
//import Html5QrcodePlugin from "html5-qrcode";
//STKICC_PC_02
let isFromLink = false;
let OrderSuccessCOunt = 0
let currentPagePath;
let strurlParams = "";
let qp = ""
let mob_Session_USERID = ""
let mob_Session_BUSUNIT = ""
let Password = ""
let Token = ""
let cribID = ""
let cameras
let WO_Num = ""
let Scan_Type = ""
let isFromFieldInventory = false
let ItemID = ""
let DeleteFlag = false
let proceed = true
let SERIAL_ID = ""
const previewStyle = {
    height: '240px',
    width: '320px',
}
/*[08/22/22 , PC_04]Accessing STKIssueCart and RMA from mobile for web view - Priyanka D*/
const urlParams = window.location.search;
if (urlParams.includes("?qp_mob")) {


    strurlParams = urlParams.toString()
    let StrURL = strurlParams.split("?qp_mob=")
    let DecodedQueryparams = StrURL[1].toString();
    qp = atob(DecodedQueryparams);
    let QueryParams = qp.split("&")
    mob_Session_USERID = QueryParams[0].replace("mob_Session_USERID=", "");
    mob_Session_BUSUNIT = QueryParams[1].replace("mob_Session_BUSUNIT=", "");
    Password = QueryParams[2].replace("Password=", "");
    Token = QueryParams[3].replace("Token=", "");
    if (QueryParams.length > 4) {
        cribID = QueryParams[4].replace("CribID=", "");
    }
    if (QueryParams.length > 6) {
        WO_Num = QueryParams[6].replace("WO_Number=", "");
    }

    if (mob_Session_USERID && mob_Session_BUSUNIT && Token) {
        isFromLink = true;
    }
}

class STKIssuesCartComponent extends Component {
    constructor(props) {
        super(props);
        this.STKCartPageload = this.STKCartPageload.bind(this);
        this.handleScan = this.handleScan.bind(this);
        this.ItemSearch = this.ItemSearch.bind(this);
        this.keyPress = this.keyPress.bind(this);
        //STKICC_PC_03
        this.state = {
            cartArr: [],
            WONUM: "",
            EmpDD: [{ value: CookieService.getLocalStorageValues("Session_UserID"), label: CookieService.getLocalStorageValues("Session_USERNAME") + " (" + CookieService.getLocalStorageValues("Session_EMAIL") + ")" }],
            SelectedEmplabel: CookieService.getLocalStorageValues("Session_UserID"),
            SelectedEmp: { value: CookieService.getLocalStorageValues("Session_UserID"), label: CookieService.getLocalStorageValues("Session_USERNAME") + " (" + CookieService.getLocalStorageValues("Session_EMAIL") + ")" },
            NewItemID: "",
            NewItemDetail: [],
            RemoveIndex: "",
            ERR: false,
            ValidWO: false, base64URL: "",
            SubmitButtonClick: false,
            ErrStatement: "",
            CUST_NOTES: "",
            ItemCheck: false,
            isFavorited: false,
            ItemIdCheck: false,
            InvalidItemId: false,
            default: { label: "Select", value: "" }, Errormsg: "", ContentClassName: isFromLink ? "container-fluid" : "container-fluid content-section content-margin", delay: 100,
            result: 'No result', QR: false, html5QrcodeScanner: "", results: [], facingMode: "environment",
            camera: "", WoStore: " ", WoPriority: " ", WoTrade: " ",
            TruckLocation: "",
            truckIdData: "",
            QtyErrorMsg: "",
            TruckOrRackOptions: "",
            qtyInPopup: false, truckInPopup: false,
            NewLocDetail: {
                area: "",
                aisle: "",
                row: "",
                shelf: "",
                bin: "",
                QuantityAvail: ""
            },
            ExistLocDetail: {
                area: "",
                aisle: "",
                row: "",
                shelf: "",
                bin: "",
                QuantityAvail: ""
            },
            ItemLocDetail: {
                area: "",
                aisle: "",
                row: "",
                shelf: "",
                bin: "",
                QuantityAvail: ""
            },
            bu: CookieService.getLocalStorageValues("Session_BUSUNIT") == " " && CookieService.getLocalStorageValues("Session_BUSUNIT") == "" && CookieService.getLocalStorageValues("Session_BUSUNIT") == null
                ? "" : CookieService.getLocalStorageValues("Session_BUSUNIT"),
            isButton: false, opLoc: false,
            TruckDDName: "", ErrorNew: "", isBin: false, existQty: "", existTruck: "",
            LocDetails: [], QtyDetails: [], EditLoc: [], QTY: "", truckSearch: false, qtyNew: "", index: 0, ItemIdNew: "", isNewPopup: false, scanType: "",
            isFromFieldInventory: (this.props.location && this.props.location.state && this.props.location.state.isFromFieldInventory) ? true : false, LabelChange: (this.props.location && this.props.location.state && this.props.location.state.isFromFieldInventory) ? true : false,
            inputFieldShow: (this.props.location && this.props.location.state && this.props.location.state.isFromFieldInventory) ? true : false

        }
        if (this.state.isFromFieldInventory) {
            isFromFieldInventory = this.props.location.state.isFromFieldInventory;
            ItemID = this.props.location.state.inv_item_id;
            SERIAL_ID = this.props.location.state.serial_id;
        }
    }
    //STKICC_PC_04
    componentDidMount() {
        //PC_743_01-If crib is not set, navigate user to profile page-Priyanka D
        if (!isFromLink) {
            if (CookieService.getLocalStorageValues("Session_ISA_CRIB_IDENT") == null || CookieService.getLocalStorageValues("Session_ISA_CRIB_IDENT") == undefined ||
                CookieService.getLocalStorageValues("Session_ISA_CRIB_IDENT") == "" || CookieService.getLocalStorageValues("Session_ISA_CRIB_IDENT") == " ") {
                //let CribID = CookieService.getLocalStorageValues("Session_ISA_CRIB_IDENT");
                if (CookieService.getLocalStorageValues("HideMobility") && CookieService.getLocalStorageValues("HideMobility").toUpperCase() == "TRUE") {
                    swal({
                        allowOutsideClick: false,
                        closeOnClickOutside: false,
                        text: "No crib has been selected. Please contact the admin/manager to assign a crib"
                    });
                    this.props.history.push({
                        pathname: `/homepage`
                    });
                }
                else {
                    swal({
                        allowOutsideClick: false,
                        closeOnClickOutside: false,
                        text: "Please select crib from user profile"
                    });
                    this.props.history.push({
                        pathname: `/profile`,
                        state: { origin: 'Inventory' }
                    });
                }
                return;
            }
        } else {
            if (cribID != "") {
                CookieService.updateLocalStorageValues("Session_ISA_CRIB_IDENT", cribID)
            } else {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: "Please select crib for your profile in walmart site"
                });
                let locObj = {
                    value: "",
                    label: ""
                }
                this.setState({ SelectedEmp: locObj });
                return
            }
        }
        proceed = true;
        CookieService.updateLocalStorageValues("Session_PageName", window.location.pathname);
        currentPagePath = this.props.location.pathname;
        currentPagePath = currentPagePath.indexOf("?") >= 0 ? currentPagePath.split("?")[0] : currentPagePath;
        let getFavPageBO = {
            Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
            pageURL: currentPagePath.toLowerCase(),
            Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT")
        };
        //if (!isFromLink) {
        STKIssuesCartAction.getCurrentFavPage(getFavPageBO);
        //}
        this.STKCartPageload();

        STKIssuesCartStore.on('DeleteUnavailableItems', this.DeleteUnavailableItemsResponse);
        STKIssuesCartStore.on('InsertAction', this.InsertActionResponse);
        STKIssuesCartStore.on('UpdateAction', this.UpdateActionResponse);
        STKIssuesCartStore.on('DeleteAction', this.DeleteActionResponse);
        STKIssuesCartStore.on('STKIssuesCartPageLoad', this.STKIssuesCartPageLoadResponse);
        STKIssuesCartStore.on('ValidateToken', this.ValidateResponse);
        STKIssuesCartStore.on('STKIssuesCartPageLoad', this.STKIssuesCartPageLoadResponse);
        STKIssuesCartStore.on('ItemSearch', this.ItemSearchResponse);
        STKIssuesCartStore.on('WOCheck', this.WOResponse);
        STKIssuesCartStore.on('WOFail', this.WOFail);
        STKIssuesCartStore.on('SubmitSTK', this.SubmitResponse);
        STKIssuesCartStore.on("OrderPDF", this.OrderPDFShow.bind(this));
        STKIssuesCartStore.on('favpage', this.loadFavPageResponse);
        STKIssuesCartStore.on('updateFavPage', this.updateFavPageResponse);
        if (isFromFieldInventory) {
            CookieService.updateLocalStorageValues("FieldInventory_RegionDD", this.props.location.state.RegionDD);
            CookieService.updateLocalStorageValues("FieldInventory_SubRegionDD", this.props.location.state.SubRegionDD);
            CookieService.updateLocalStorageValues("FieldInventory_TruckidDD", this.props.location.state.TruckidDD);
            CookieService.updateLocalStorageValues("FieldInventory_TechNameDD", this.props.location.state.TechNameDD);
            CookieService.updateLocalStorageValues("FieldInventory_RegionValue", this.props.location.state.RegionValue);
            CookieService.updateLocalStorageValues("FieldInventory_SubRegionValue", this.props.location.state.SubRegionValue);
            CookieService.updateLocalStorageValues("FieldInventory_TruckidValue", this.props.location.state.TruckidValue);
            CookieService.updateLocalStorageValues("FieldInventory_TechNameValue", this.props.location.state.TechNameValue);
            CookieService.updateLocalStorageValues("FieldInventory_SearchTxt", this.props.location.state.SearchTxt);
            CookieService.updateLocalStorageValues("FieldInventory_UserId", this.props.location.state.UserId);
            CookieService.updateLocalStorageValues("FieldInventory_PageLoadData", this.props.location.state.PageLoadData);
            CookieService.updateLocalStorageValues("FieldInventory_IncludeZeroCheck", this.props.location.state.IncludeZeroCheck);
        }
        let cart = this.state.cartArr.length > 0 ? this.state.cartArr : CookieService.getLocalStorageValues("STKCart") != null && CookieService.getLocalStorageValues("STKCart") != undefined ? CookieService.getLocalStorageValues("STKCart") : []
        this.setState({ cartArr: cart });

        let truckrackId = this.state.cartArr.length > 0 ? this.state.TruckOptions : CookieService.getLocalStorageValues("TruckId") != null && CookieService.getLocalStorageValues("TruckId") != undefined ? CookieService.getLocalStorageValues("TruckId") : []
        this.setState({ TruckOptions: truckrackId });
        /**if (isFromLink) {
            document.getElementById("ContentDiv").style.marginTop = "44px"
        } else {
            document.getElementById("ContentDiv").style.marginTop = "198px"
        }*/
    }
    //STKICC_PC_05
    componentWillUnmount() {
        isFromFieldInventory = false;
        STKIssuesCartStore.removeListener('DeleteUnavailableItems', this.DeleteUnavailableItemsResponse);
        STKIssuesCartStore.removeListener('STKIssuesCartPageLoad', this.STKIssuesCartPageLoadResponse);
        STKIssuesCartStore.removeListener('DeleteAction', this.DeleteActionResponse);
        STKIssuesCartStore.removeListener('InsertAction', this.InsertActionResponse);
        STKIssuesCartStore.removeListener('UpdateAction', this.UpdateActionResponse);
        STKIssuesCartStore.removeListener('ValidateToken', this.ValidateResponse);
        STKIssuesCartStore.removeListener('ItemSearch', this.ItemSearchResponse);
        STKIssuesCartStore.removeListener('WOCheck', this.WOResponse);
        STKIssuesCartStore.removeListener('WOFail', this.WOFail);
        STKIssuesCartStore.removeListener('SubmitSTK', this.SubmitResponse);
        STKIssuesCartStore.removeListener("OrderPDF", this.OrderPDFShow.bind(this));
        STKIssuesCartStore.removeListener('favpage', this.loadFavPageResponse);
        STKIssuesCartStore.removeListener('updateFavPage', this.updateFavPageResponse);


    }

    onScanSuccess = (decodedText, decodedResult) => {
        // Handle on success condition with the decoded text or result.
        console.log(`Scan result: ${decodedText}`, decodedResult);
    }

    onStart = (camera) => {
        this.setState({
            camera
        });
        console.log("camera", camera);
    }
    onScan = (content) => {
        const results = this.state.results;
        results.unshift({
            date: Date.now(),
            content
        });
        this.setState({
            results
        });
        console.log("QR_SCANNER", results);
        console.log("QR_SCANNER content", content);
    }
    ValidateToken = () => {

        let BO = {
            Session_USERID: mob_Session_USERID,
            Token: Token,
            Password: Password,
        }
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        STKIssuesCartAction.ValidateToken(BO);
    }
    //PC_03
    handleScan = (err, data) => {
        if (data != null) {
            this.setState({
                result: data,
            })
            $('#QR_Scanner_Popup').modal('hide');
            this.setState({ QR: false });
            console.error("QRSCANNER", data);
            $('#Add-New-Item').modal('show');
            $("#NewItemID").val(data.text)
            this.ItemSearch("");

        }
        else {
            console.log("QR_ERROR", err);
        }
    }
    //PC_04
    handleError(err) {
        console.error(err)
    }
    //_PC_5
    //CPW-184 Stock Issue Panel Changes
    QR_Scanner = (Type) => {

        if (Type == "1") {
            Scan_Type = "1"
            $('#Add-New-Item').modal('hide');
        }
        else if (Type == "2") {
            Scan_Type = "1"
            $('#QR_Scanner_ManualPopup').modal('hide');
            $('#QR_Scanner_Popup').modal('show');

        }
        else {
            Scan_Type = "2"
        }
        this.setState({ QR: true });
    }
    //_PC_6
    //CPW-184 Stock Issue Panel Changes
    CloseQR = () => {
        if (Scan_Type == "1") {
            $('#Add-New-Item').modal('show');
        }
        $('#QR_Scanner_ManualPopup').modal('show');
        this.setState({ QR: false });
    }



    handleQRScan = (err, data) => {
        console.error("QRSCANNER", data);

        if (data != null && data != undefined) {
            $('#QR_Scanner_ManualPopup').modal('hide');

            this.setState({
                ItemIdNew: data.text, NewItemID: data.text, QR: false
            })
            this.ItemSearch("");
        }
        else {
            console.log("QR_ERROR", err);

        }
        $('#Add-New-Item').modal('show');

    }



    handleQRScanError = () => {

        this.setState({ QRError: true })
    }

    handleOpenQR = (e, type) => {
        $('#Add-New-Item').modal('hide');
        if (type == "1") {
            this.setState({ scanType: "1" })
        }
        this.setState({ QR: true })
    }

    handleCloseQR = () => {

        if (this.state.scanType == "1") {
            $('#Add-New-Item').modal('show');
        }
        else {
            $('#Add-New-Item').modal('hide');
        }
        this.setState({ QR: false })

    }


    //STKICC_PC_06
    STKCartPageload() {

        let BO = {
            Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
            Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
            Session_THIRDPARTY_COMP_ID: CookieService.getLocalStorageValues("Session_THIRDPARTY_COMP_ID"),
            Session_ACTIVEUSERS: CookieService.getLocalStorageValues("Session_ACTIVEUSERS"),
            IsFromMob: false,
            IsTrucUser: (CookieService.getLocalStorageValues("Session_TRUCK_USER") && CookieService.getLocalStorageValues("Session_TRUCK_USER").toLowerCase() == "true") || isFromFieldInventory,
            ShipToID: CookieService.getLocalStorageValues("Session_TRUCK_USER") === "True" ? (CookieService.getLocalStorageValues("Session_TRUCK_STORAGE_AREA")) : (CookieService.getLocalStorageValues("HOME_STORE") ? CookieService.getLocalStorageValues("HOME_STORE") : " "),
            COSINGED: true,
            Session_SITEPREFIX: CookieService.getLocalStorageValues("Session_SITEPREFIX"),
            Session_ITEMMODE: CookieService.getLocalStorageValues("Session_ITEMMODE"),
        }
        if (WO_Num != undefined && WO_Num != null && WO_Num != "") {
            this.setState({ WONUM: WO_Num });
            this.WorkOrderInputCheck();
        }
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        STKIssuesCartAction.STKIssuesCartAction(BO)
    }
    ValidateResponse = () => {
        let ValidateResponse = JSON.parse(STKIssuesCartStore.PageLoadData);
        if (ValidateResponse.ErrorMessage != undefined) {
            if (ValidateResponse.ErrorMessage[0] != undefined) {
                if (ValidateResponse.ErrorMessage[0].lblerror == "InvalidToken") {
                    swal({
                        allowOutsideClick: false,
                        closeOnClickOutside: false,
                        text: "Please login again"
                    });
                    return
                }
            }
        } else {
            this.STKCartPageload()
        }
    }
    InsertActionResponse = () => {
        let parsedResponse = JSON.parse(STKIssuesCartStore.InsertAction);
        let cartData = [];
        let unavailableItems = [];
        DeleteFlag = false;
        if (parsedResponse === "Technical issue") {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Technical Issue. Please contact SDI Customer Care"
            });


        }
        else {
            cartData = parsedResponse;
            this.props.toastSuccessMessage("Item successfully added to cart")

        }
        cartData.forEach(item => {
            if (item.IsQtyAvailable === true) {
                unavailableItems.push(item);
            }
        });

        if (unavailableItems && unavailableItems.length > 0) {
            this.setState({ cartArr: cartData, LabelChange: false, inputFieldShow: false, unavailableItems });
            $(`#${SDIConstants.SDILoader}`).addClass('hide');
            $('#QTY-popup').modal('show');
            return;
        }

        this.setState({ cartArr: cartData, LabelChange: false, inputFieldShow: false, unavailableItems });
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
    }
    DeleteActionResponse = () => {
        let parsedResponse = JSON.parse(STKIssuesCartStore.DeleteAction);
        let cartData = [];
        if (parsedResponse === "Technical issue") {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Technical Issue. Please contact SDI Customer Care"
            });


        }
        else {
            if (this.state.RemovePopup === false) {
                cartData = parsedResponse.StockItems;
            }

        }
        this.setState({ cartArr: cartData })

        $(`#${SDIConstants.SDILoader}`).addClass('hide');

    }
    UpdateActionResponse = () => {
        let parsedResponse = JSON.parse(STKIssuesCartStore.UpdateAction);
        let cartData = [];
        if (parsedResponse === "Technical issue") {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Technical Issue. Please contact SDI Customer Care"
            });


        }
        else {
            cartData = parsedResponse;

        }
        this.setState({ cartArr: cartData })

        $(`#${SDIConstants.SDILoader}`).addClass('hide');

    }
    //STKICC_PC_07
    STKIssuesCartPageLoadResponse = () => {

        let PageLoadResponse = JSON.parse(STKIssuesCartStore.PageLoadData);
        let EmpId = PageLoadResponse.EmpData;
        let LocEMPDD = [];
        let unavailableItems = [];
        let cartArr = PageLoadResponse.CartData;
        //CPW -145_PC_01 -Aparna
        let locSelectedEmp = {}
        console.log("PageLoadResponse", PageLoadResponse)
        // Filter items with IsQtyAvailable as false
        if (isFromFieldInventory) {
            CookieService.updateLocalStorageValues("FieldInventory_cleardata", true);
        } else {
            CookieService.updateLocalStorageValues("FieldInventory_cleardata", false);
        }
        cartArr.forEach(item => {
            if (item.IsQtyAvailable === true) {
                unavailableItems.push(item);
            }
        });

        if (unavailableItems.length > 0 && isFromFieldInventory === false) {
            $('#QTY-popup').modal('show');
        }
        EmpId.forEach((value, index) => {
            let Emp = {
                value: value.EMP_ID,
                label: value.ISA_EMPLOYEE_NAME + " (" + value.ISA_EMPLOYEE_EMAIL + ")"
            }
            LocEMPDD.push(Emp)
            //CPW-145_PC_01 -Aparna
            //if (CookieService.getLocalStorageValues("Session_UserID") == value.EMP_ID) {
            //    locSelectedEmp = Emp
            //}
        })
        let locObj = {
            value: CookieService.getLocalStorageValues("Session_UserID"),
            label: CookieService.getLocalStorageValues("Session_USERNAME") + " (" + CookieService.getLocalStorageValues("Session_EMAIL") + ")"
        }
        locSelectedEmp = locObj
        this.setState({ EmpDD: LocEMPDD, SelectedEmp: locSelectedEmp, cartArr, unavailableItems });
        if (!isFromFieldInventory) {
            $(`#${SDIConstants.SDILoader}`).addClass('hide');
        } else {
            if (this.state.isFromFieldInventory && ItemID) {
                let STKCartStorage = cartArr
                let ItemIDExist = STKCartStorage.some((item) => {
                    if (item.ItemId === ItemID || item.MFGID === ItemID) {
                        this.setState({ ItemCheck: true, ItemIdCheck: false, InvalidItemId: false });
                        return true;
                    }
                    return false;
                });
                if (ItemIDExist) {

                    this.setState({ NewItemID: ItemID, inputFieldShow: false });
                    $('#Add-New-Item').modal('show');

                } else {
                    let BO = {
                        ItemId: ItemID.toUpperCase(),
                        Session_USERID: this.props.location.state.employee_id,
                        IsFromField: true,
                        for_USERID: CookieService.getLocalStorageValues("Session_UserID"),
                        Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
                        AGENTUSERID: CookieService.getLocalStorageValues("Session_AGENTUSERID"),
                        AGENTUSERBU: CookieService.getLocalStorageValues("Session_AGENTUSERID"),
                        Session_SDIEMP: CookieService.getLocalStorageValues("Session_SDIEMP"),
                        Session_UserName: CookieService.getLocalStorageValues("Session_USERNAME"),
                        Session_SDICAT: CookieService.getLocalStorageValues("Session_SDICAT"),
                        Session_CplusDB: CookieService.getLocalStorageValues("Session_CplusDB"),
                        Session_USESOLRSEARCH: CookieService.getLocalStorageValues("Session_USESOLRSEARCH"),
                        Session_SEARCH3M: CookieService.getLocalStorageValues("Session_SEARCH3M"),
                        Session_SEARCHORONASCO: CookieService.getLocalStorageValues("Session_SEARCHORONASCO"),
                        Session_SEARCHCAPP: CookieService.getLocalStorageValues("Session_SEARCHCAPP"),
                        Session_SEARCHMSC: CookieService.getLocalStorageValues("Session_SEARCHMSC"),
                        Session_SEARCHIMP: CookieService.getLocalStorageValues("Session_SEARCHIMP"),
                        Session_SEARCHSTAUFFER: CookieService.getLocalStorageValues("Session_SEARCHSTAUFFER"),
                        Session_CplusDbSQL: CookieService.getLocalStorageValues("Session_CplusDbSQL"),
                        Session_AMAZONSEARCH: CookieService.getLocalStorageValues("Session_AMAZONSEARCH"),
                        SOURCE: "WEB",
                        Session_SITEPREFIX: CookieService.getLocalStorageValues("Session_SITEPREFIX"),
                        Session_CUSTID: CookieService.getLocalStorageValues("Session_CUSTID"),
                        Session_ITEMMODE: CookieService.getLocalStorageValues("Session_ITEMMODE"),
                        COSINGED: true,
                        Location: CookieService.getLocalStorageValues("Session_STATE") != null ? CookieService.getLocalStorageValues("Session_STATE") : "",
                        ShipToID: this.props.location.state.isa_truck_id,
                        IsTrucUser: (CookieService.getLocalStorageValues("Session_TRUCK_USER") && CookieService.getLocalStorageValues("Session_TRUCK_USER").toLowerCase() == "true") || isFromFieldInventory,
                        IsTruckUser: "true",
                        Truck_ShipTo: CookieService.getLocalStorageValues("Session_TRUCK_SHIPTO_ID"),
                        truckIdData: this.props.location.state.isa_truck_id,
                        truckSearch: false,
                        FromFieldInventory: true,
                    };
                    $(`#${SDIConstants.SDILoader}`).removeClass('hide');
                    STKIssuesCartAction.ItemSearchAction(BO);
                }
            }
        }

    }
    DeleteUnavailableItemsResponse = () => {
        const response = JSON.parse(STKIssuesCartStore.DeleteUnavailableItems);
        if (response === 'Technical issue') {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: 'Technical Issue. Please contact SDI Customer Care'
            });
        } else {
            this.setState({ cartArr: response.StockItems });
        }
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
    }

    loadFavPageResponse = () => {
        let favPageResponse = JSON.parse(STKIssuesCartStore.currentFavPageResponse);
        if (favPageResponse.length > 0) {
            favPageResponse = favPageResponse[0];
            this.setState({ isFavorited: true, Page_ID: favPageResponse.PAGE_ID });
        };
    };
    updateFavPageResponse = () => {
        if (STKIssuesCartStore.updateFavPageResponse.updateType == 1) {

            let response = JSON.parse(STKIssuesCartStore.updateFavPageResponse.responseStr)[0];
            if (response.is_Success == "True") {
                $(`#${SDIConstants.SDILoader}`).addClass('hide');
                this.setState({ isFavorited: true, Page_ID: response.Page_ID });
                MenuAction.toastMessage(1);
            }

        } else {
            let response = JSON.parse(STKIssuesCartStore.updateFavPageResponse.responseStr)[0];
            if (response.success == "true") {
                $(`#${SDIConstants.SDILoader}`).addClass('hide');
                this.setState({ isFavorited: false });
                MenuAction.toastMessage(2);
            }
        }
        // isPostBack = false;
        //this.refreshMenu();
        MenuAction.refreshMasterData()
    };
    //STKICC_PC_
    handleFavorite = (event) => {
        this.setState({ isFavorited: event.target.checked });
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        if (event.target.checked == true) {
            let insertFavPageBO = {
                Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
                pageURL: currentPagePath.toLowerCase(),
                pageTitle: "Stock Issue",
                Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT")
            }
            STKIssuesCartAction.insertFavPage(insertFavPageBO)
        } else {
            let deleteFavPageBO = {
                Page_ID: this.state.Page_ID
            }
            STKIssuesCartAction.deleteFavPage(deleteFavPageBO)
        }
    };
    //STKICC_PC_18
    WOResponse = () => {
        //CPW-220 Service Channel details not populated when using Stock Issue - Deepthi N H
        let Workorderresponse = JSON.parse(STKIssuesCartStore.workorderresponse);
        let WoTrade = "";
        let WoPriority = "";
        let WoStore = "";
        let loacalloc = "";
        if (Workorderresponse != undefined && Workorderresponse != null) {
            if (Workorderresponse.WOResponse != undefined && Workorderresponse.WOResponse != "") {
                if (Workorderresponse.WOResponse.length > 0) {

                    if (Workorderresponse.WOResponse[0].Trade != undefined && Workorderresponse.WOResponse[0].Trade != null) {
                        WoTrade = Workorderresponse.WOResponse[0].Trade;
                    }
                    if (Workorderresponse.WOResponse[0].Priority != undefined && Workorderresponse.WOResponse[0].Priority != null) {
                        WoPriority = Workorderresponse.WOResponse[0].Priority;
                    }
                    if (Workorderresponse.WOResponse[0].ADDRESS1 != undefined && Workorderresponse.WOResponse[0].ADDRESS1 != null) {
                        WoStore = Workorderresponse.WOResponse[0].ADDRESS1 + " - " + Workorderresponse.WOResponse[0].DESCR_AC;
                    }

                    //WW-1374 Update the WO store, logo, Problem code long and short description to cookie - Nandhini L                  
                    loacalloc = Workorderresponse.WOResponse[0].LOCATION
                    localStorage.setItem("StoreValue", JSON.stringify(loacalloc));

                    CookieService.updateLocalStorageValues("Trade", Workorderresponse.WOResponse[0].Trade);

                    CookieService.updateLocalStorageValues("Logo", Workorderresponse.WOResponse[0].Logo);
                    CookieService.updateLocalStorageValues("ProblemCodeDescription", Workorderresponse.WOResponse[0].ProblemCodeDescription);
                    CookieService.updateLocalStorageValues("Description", Workorderresponse.WOResponse[0].Description);

                }
            }
        }
        if (Workorderresponse.WOResponse[0].LOCATION === "W09301" || Workorderresponse.WOResponse[0].LOCATION === "W02409") {
            this.setState({ ERR: true, ErrStatement: "Enter valid work order #", SubmitButtonClick: false, ValidWO: false });

        } else {
            this.setState({ ERR: false, ErrStatement: "", ValidWO: true, WoStore: WoStore, WoPriority: WoPriority, WoTrade: WoTrade });
            if (this.state.SubmitButtonClick) {
                this.SubmitValidation()
            }
        }


    }
    //STKICC_PC_19
    WOFail = () => {
        if (CookieService.getLocalStorageValues("Session_CARTWOREQ") == 'N' && this.state.WONUM == "") {
            if (this.state.SubmitButtonClick) {
                this.setState(() => {
                    const newState = {
                        ERR: false,
                        ErrStatement: "",
                        ValidWO: true
                    };
                    return newState;
                }, () => {
                    this.SubmitValidation();
                });
            }
            else {
                this.setState({ ERR: true, ErrStatement: "Enter valid work order #", SubmitButtonClick: false, ValidWO: false });
            }
        }
        else {
            this.setState({ ERR: true, ErrStatement: "Enter valid work order #", SubmitButtonClick: false, ValidWO: false });
        }
    }

    //STKICC_PC_10
    ItemSearchResponse = () => {
        let Response = JSON.parse(STKIssuesCartStore.PageLoadData);
        let LocItemDetail = Response.ItemDetail
        let cartArr = Response.CartData
        let TruckRackData;
        let TruckLocation;
        let LocDetails;
        let QtyDetails;
        TruckRackData = Response.TruckIdDT
        TruckLocation = Response.DefTruckId[0].Data
        LocDetails = LocItemDetail[0].Loc
        QtyDetails = LocItemDetail[0].QtyAvailableTruck
        let locinvalid = false
        let index = this.state.index

        let isTruck = false
        let Error = ""
        let Error1 = ""

        if (LocItemDetail != undefined && LocItemDetail != null) {
            if (LocItemDetail.length > 0) {
                if ((LocItemDetail[0].ItemId == "" || LocItemDetail[0].ItemId == null || LocItemDetail[0].ItemId == undefined) || LocItemDetail[0].HasError == "True") {
                    if (LocItemDetail[0].ZeroQty == "True") {
                        if (TruckLocation != "") {
                            if (this.state.isNewPopup == true) {
                                this.state.isNewPopup = false
                            }
                            Error = "This item id is not available for the selected Truck or Rack ID"
                            Error1 = "This item id is not available for the selected Truck or Rack ID"
                            isTruck = true
                        }
                        else {
                            Error = "Qty not available"
                            Error1 = "Qty not available"
                            isTruck = false
                        }
                        locinvalid = true

                    }
                    else if (LocItemDetail[0].ZeroQty == "" || LocItemDetail[0].ZeroQty == null || LocItemDetail[0].ZeroQty == undefined) {
                        Error = "Part number not found in this location. Please provide a valid part number for this location"
                        Error1 = "Part number not found in this location. Please provide a valid part number for this location"

                        locinvalid = true
                    }
                }

                else {
                    if (LocItemDetail[0].MFG == "" || LocItemDetail[0].MFG == undefined || LocItemDetail[0].MFG == null) {
                        locinvalid = true
                    }
                    else {
                        if (TruckLocation != "" && TruckLocation != undefined && TruckLocation != null) {
                            if (LocDetails.length > 0) {
                                isTruck = true

                                let locArray = LocDetails.split(" ");

                                let ItemLocDetail = {
                                    area: locArray[0],
                                    aisle: locArray[1],
                                    row: locArray[2],
                                    shelf: locArray[3],
                                    bin: locArray[4],
                                    QuantityAvail: QtyDetails,
                                }
                                // LocDetails[0].IsLocSelected = true;

                                this.setState({
                                    ItemLocDetail: ItemLocDetail, LocDetails: LocDetails, QtyDetails: QtyDetails, NewLocDetail: ItemLocDetail, cartArr
                                })
                                if (this.state.cartArr.length > 0 && this.state.truckSearch == true) {
                                    this.state.cartArr[index].SelectedArea = ItemLocDetail.area
                                    this.state.cartArr[index].SelectedAisle = ItemLocDetail.aisle
                                    this.state.cartArr[index].SelectedRow = ItemLocDetail.row
                                    this.state.cartArr[index].SelectedShelf = ItemLocDetail.shelf
                                    this.state.cartArr[index].SelectedBin = ItemLocDetail.bin
                                    this.state.cartArr[index].QtyAvailable = QtyDetails
                                }
                            }
                        }
                    }
                }
            }
            this.BindTruckRackDD(TruckRackData, TruckLocation)

            if (this.state.truckSearch == false) {
                TruckLocation = TruckLocation
            }
            else {
                TruckLocation = this.state.TruckLocation
            }
            if (isFromFieldInventory === true) {
                $('#Add-New-Item').modal('show');
            }
            this.setState({ NewItemDetail: LocItemDetail, truckSearch: false, isButton: true, ItemCheck: false, truckInPopup: isTruck, TruckLocation: TruckLocation, ItemIdCheck: false, isNewPopup: true, InvalidItemId: locinvalid, ErrorNew: Error1, Errormsg: Error, cartArr });
        }
    }



    BindTruckRackDD = (TruckRack, TruckLocation) => {
        let TruckDDvalue = []
        let TruckDD = []
        if (TruckRack.length > 0) {
            TruckRack.forEach((value, index) => {

                if (value.ISA_TRUCK_ID == TruckLocation) {
                    let loc = {
                        value: value.ISA_TRUCK_ID,
                        label: value.STORAGE_AREA
                    }
                    TruckDD.push(loc)
                }
                let locObj = {
                    value: value.ISA_TRUCK_ID,
                    label: value.STORAGE_AREA
                }
                TruckDDvalue.push(locObj);
            });
        }
        this.setState({ TruckOptions: TruckDDvalue, TruckDDName: TruckDD[0] })
    }

    handleTruckDDChange = (values) => {
        let truckLoc = values.label;
        if (this.state.cartArr.length > 0 && this.state.opLoc == true) {
            this.state.cartArr[this.state.index].TruckLocation = truckLoc
        }
        this.setState(
            { TruckDDName: values, TruckLocation: truckLoc, truckInPopup: true, truckSearch: true },
            () => {
                this.ItemSearch(truckLoc);
            }
        )
    }

    // To handle Radio button in the Inventory location grid
    OnHandleGridRadChange = (e, Gindex) => {

        let locGrid = this.state.ItemLocDetail;
        if (locGrid.length == 1) {
            return;
        }
        else if (locGrid.length > 1) {
            locGrid.forEach((value, index) => {
                if (index == Gindex) {
                    value.IsLocSelected = true;
                    this.setState({
                        ItemLocDetail: locGrid, SelectedArea: value.area,
                        SelectedAisle: value.aisle, SelectedRow: value.row, SelectedShelf: value.shelf, SelectedBin: value.bin, SelectedBU: this.state.bu, SelectedCurQty: parseInt(value.QuantityAvail)
                    });
                }
                else {
                    value.IsLocSelected = false;
                }
            });
        }
    }


    //STKICC_PC_08
    OnChangeField = (name, event, index) => {
        const re = SDIConstants.quantityRegEX;
        let numRegex = /^\d+$/;

        switch (name) {
            case "Emp": {
                this.setState({ SelectedEmp: event });
                break;
            }
            case "QTY": {
                const fieldType = event.target.getAttribute("data-type");
                const index = event.target.getAttribute("data-index");
                let { cartArr } = this.state;
                let currentQty = parseInt(cartArr[index].Qty)||0;
                let enteredValue = event.target.value;//parseInt(event.target.value) || 0;

                if (fieldType === "increment") {
                    currentQty = currentQty + 1;
                } else if (fieldType === "decrement") {
                    currentQty = currentQty - 1;
                } else if (fieldType === "enterqty") {
                    if ((enteredValue > cartArr[index].QtyAvailable || enteredValue < 1) || !re.test(enteredValue)) {
                        if (!re.test(enteredValue) || enteredValue === "0" || parseInt(enteredValue)===0) {
                            if (enteredValue === "" || enteredValue === "0" || parseInt(enteredValue)===0) {
                                cartArr[index].Qty = enteredValue;
                                this.setState({ ERR: true, ErrStatement: "Please enter a valid quantity.", cartArr });
                                return
                            }
                            this.setState({cartArr});
                            return
                        }
                        else {

                            currentQty = enteredValue;
                        }

                        cartArr[index].Qty = currentQty;
                        this.setState({ ERR: true,ErrStatement:"The quantity should be less than or equal to the available quantity" , cartArr });
                        return
                    } else {
                        currentQty = enteredValue;
                        if (event.type === "change" && re.test(enteredValue)) {
                            cartArr[index].Qty = currentQty;
                            this.setState({
                                cartArr, ERR: false, ErrStatement: ''
                            });
                            return
                        }
                    }

                }

                cartArr[index].Qty = currentQty;
                this.setState({ cartArr, ERR: (currentQty > cartArr[index].QtyAvailable || currentQty < 1) ? true : false, ErrStatement: (currentQty > cartArr[index].QtyAvailable || currentQty < 1) ? "The quantity should be less than or equal to the available quantity":'' });
                const UpdateBO = {
                    ISA_EMPLOYEE_ID: CookieService.getLocalStorageValues("Session_UserID") == "" || undefined || null ? "" : CookieService.getLocalStorageValues("Session_UserID"),
                    ITEM_ID: cartArr[index].ItemId,
                    QUANTITY: currentQty,
                    DeleteFlag: "Update",
                    IsTrucUser: (CookieService.getLocalStorageValues("Session_TRUCK_USER") && CookieService.getLocalStorageValues("Session_TRUCK_USER").toLowerCase() == "true") || isFromFieldInventory,
                    ShipToID: CookieService.getLocalStorageValues("Session_TRUCK_USER") === "True" ? (CookieService.getLocalStorageValues("Session_TRUCK_STORAGE_AREA")) : (CookieService.getLocalStorageValues("HOME_STORE") ? CookieService.getLocalStorageValues("HOME_STORE") : " "),
                    COSINGED: true,
                    Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
                    Session_SITEPREFIX: CookieService.getLocalStorageValues("Session_SITEPREFIX"),
                    Session_ITEMMODE: CookieService.getLocalStorageValues("Session_ITEMMODE"),

                };
                $(`#${SDIConstants.SDILoader}`).removeClass('hide');
                STKIssuesCartAction.UpdateAction(UpdateBO);
                break;
            }
            case "QTY2": {
                if (event.target.value != 0) {
                    this.setState({ InvalidItemId: false })
                }
                if (event.target.value == "" || numRegex.test(event.target.value.trim())) {
                    this.setState({ QTY: event.target.value, QtyErrorMsg: "", qtyNew: event.target.value })
                }

                break;
            }
            case "QTY3": {
                if (event.target.value == "" || re.test(event.target.value)) {
                    let { cartArr } = this.state
                    cartArr[index].QTY = event.target.value;
                }
                break;
            }

            case "Remove": {
                let { cartArr } = this.state
                const itemToRemove = cartArr[index];
                let DeleteBO = {
                    ISA_EMPLOYEE_ID: CookieService.getLocalStorageValues("Session_UserID") == "" || undefined || null ? "" : CookieService.getLocalStorageValues("Session_UserID"),
                    ITEM_ID: itemToRemove.ItemId,
                    QUANTITY: itemToRemove.Qty ? itemToRemove.Qty:"0.0",
                    DeleteFlag: "false",
                    IsTrucUser: (CookieService.getLocalStorageValues("Session_TRUCK_USER") && CookieService.getLocalStorageValues("Session_TRUCK_USER").toLowerCase() == "true") || isFromFieldInventory,
                    ShipToID: CookieService.getLocalStorageValues("Session_TRUCK_USER") === "True" ? (CookieService.getLocalStorageValues("Session_TRUCK_STORAGE_AREA")) : (CookieService.getLocalStorageValues("HOME_STORE") ? CookieService.getLocalStorageValues("HOME_STORE") : " "),
                    COSINGED: true,
                    Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
                    Session_SITEPREFIX: CookieService.getLocalStorageValues("Session_SITEPREFIX"),
                    Session_ITEMMODE: CookieService.getLocalStorageValues("Session_ITEMMODE"),
                }
                $(`#${SDIConstants.SDILoader}`).removeClass('hide');
                this.setState({ RemovePopup: false });
                STKIssuesCartAction.DeleteAction(DeleteBO);

                cartArr.splice(index, 1)
                CookieService.updateLocalStorageValues("STKCart", cartArr);
                this.setState({ ERR: false });

                break;
            }
            case "WO": {
                if (event.target.value === '' || re.test(event.target.value)) {
                    this.setState({ WONUM: event.target.value, ValidWO: false, ERR: false });
                }
                console.log("WO#", this.state.WONUM);
                break;
            }
            case "CUST_NOTES": {
                this.setState({ CUST_NOTES: event.target.value });
                //console.log("WO#", this.state.WONUM);
                break;
            }
            case "ItemId": {
                this.setState({
                    NewItemID: event.target.value, ItemIdCheck: "", Errormsg: "", ItemCheck: false, ItemIdCheck: false, NewItemDetail: [], InvalidItemId: false, NewLocDetail: [], LocDetails: [], QtyErrorMsg: "", qtyInPopup: false, isButton: false, truckInPopup: false, QtyErrormsg: ""
                })

            }
        }

    }
    //STKICC_PC_17
    WorkOrderInputCheck = () => {
        if (this.state.WONUM == "" && !this.state.SubmitButtonClick) {
            this.setState({ ERR: true, ErrStatement: "Please enter work order #" });
            return;
        }
        else {
            if (CookieService.getLocalStorageValues("Session_CC_VALIDATE_WO") != 'N') {
                let THIRDPARTY_COMP_ID = ""
                if (CookieService.getLocalStorageValues("Session_THIRDPARTY_COMP_ID") != null) {
                    THIRDPARTY_COMP_ID = CookieService.getLocalStorageValues("Session_THIRDPARTY_COMP_ID")
                }
                let BO = {
                    workOrder: this.state.WONUM,
                    Session_THIRDPARTY_COMP_ID: THIRDPARTY_COMP_ID,
                    User_Type: CookieService.getLocalStorageValues("Session_SDIEMP") //WW-336 - PC_04 CBRE WO# validation is not working for SDI Users(1/ 18 / 2022)  -Aparna
                }
                $(`#${SDIConstants.SDILoader}`).removeClass('hide');

                STKIssuesCartAction.WorkOrderCheck(BO)
                this.setState({ workorderclick: true, submitbtn: false });
            }
            else {
                this.setState(() => {
                    const newState = {
                        ERR: false,
                        ErrStatement: "",
                        ValidWO: true
                    };
                    return newState;
                }, () => {
                    if (this.state.SubmitButtonClick) {
                        this.SubmitValidation();
                    }
                });
            }
        }
    }

    //STKICC_PC_
    keyPress(e) {
        if (e.keyCode == 13) {
            //;
            if ($("#NewItemID").val() != "") {
                this.ItemSearch("");
            }
            else {
                // alert("Please enter Item Id");
                this.setState({ ItemIdCheck: true })
            }

        }
    }
    //STKICC_PC_
    RemoveItem = (Index) => {

        this.setState({ RemoveIndex: Index });
        $('#Cancel-confirmation').modal('show');
        /*[02/09/22, PC_01,WW-318], Priyanka D,Removing item from Enersys List */
    }
    //STKICC_PC_09
    ItemSearch = (TruckLocation) => {
        let a = CookieService.getLocalStorageValues("Session_TRUCK_USER");
        let b = CookieService.getLocalStorageValues("Session_TRUCK_STORAGE_AREA");
        let c = CookieService.getLocalStorageValues("HOME_STORE");
        let valid = true;
        let newitem = ""
        if (($("#NewItemID").val().trim() != "" && $("#NewItemID").val() != null && $("#NewItemID").val() != undefined) || this.state.ItemIdNew != "" && this.state.cartArr[this.state.index].ItemId != "") {

            if (this.state.NewItemID != "" && this.state.NewItemID != null && this.state.NewItemID != undefined) {
                newitem = this.state.NewItemID
            }
            else if (this.state.cartArr.length > 0 && this.state.truckSearch == true) {
                if (this.state.cartArr[this.state.index].ItemId != "" && this.state.cartArr[this.state.index].ItemId != null && this.state.cartArr[this.state.index].ItemId != undefined) {
                    newitem = this.state.cartArr[this.state.index].ItemId
                }
            }
            this.state.cartArr.forEach((item, index) => {
                //CPW-184 Stock Issue Panel Changes
                if (item.ItemId == newitem || item.MFGID == newitem) {
                    if (this.state.TruckLocation == "" && this.state.NewItemID.trim() != "") {
                        valid = false
                        this.setState({ ItemCheck: true, ItemIdCheck: false, InvalidItemId: false });
                    }
                    else if (this.state.TruckLocation != "" && this.state.truckSearch == true) {
                        valid = true
                    }
                    else {
                        valid = false
                        this.setState({ ItemCheck: true, ItemIdCheck: false, InvalidItemId: false });
                    }

                }
            })
        }
        else {
            valid = false
            this.setState({ ItemIdCheck: true, ItemCheck: false, InvalidItemId: false });
        }
        if (valid) {
            if (this.state.cartArr.length > 0) {
                TruckLocation = this.state.cartArr[0].TruckLocation
            }
            let BO = {
                ItemId: newitem.toUpperCase(),
                Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
                Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
                AGENTUSERID: CookieService.getLocalStorageValues("Session_AGENTUSERID"),
                AGENTUSERBU: CookieService.getLocalStorageValues("Session_AGENTUSERID"),
                Session_SDIEMP: CookieService.getLocalStorageValues("Session_SDIEMP"),
                Session_UserName: CookieService.getLocalStorageValues("Session_USERNAME"),
                Session_SDICAT: CookieService.getLocalStorageValues("Session_SDICAT"),
                Session_CplusDB: CookieService.getLocalStorageValues("Session_CplusDB"),
                Session_USESOLRSEARCH: CookieService.getLocalStorageValues("Session_USESOLRSEARCH"),
                Session_SEARCH3M: CookieService.getLocalStorageValues("Session_SEARCH3M"),
                Session_SEARCHORONASCO: CookieService.getLocalStorageValues("Session_SEARCHORONASCO"),
                Session_SEARCHCAPP: CookieService.getLocalStorageValues("Session_SEARCHCAPP"),
                Session_SEARCHMSC: CookieService.getLocalStorageValues("Session_SEARCHMSC"),
                Session_SEARCHIMP: CookieService.getLocalStorageValues("Session_SEARCHIMP"),
                Session_SEARCHSTAUFFER: CookieService.getLocalStorageValues("Session_SEARCHSTAUFFER"),
                Session_CplusDbSQL: CookieService.getLocalStorageValues("Session_CplusDbSQL"),
                Session_AMAZONSEARCH: CookieService.getLocalStorageValues("Session_AMAZONSEARCH"),
                SOURCE: "WEB",
                Session_SITEPREFIX: CookieService.getLocalStorageValues("Session_SITEPREFIX"),
                Session_CUSTID: CookieService.getLocalStorageValues("Session_CUSTID"),
                Session_ITEMMODE: CookieService.getLocalStorageValues("Session_ITEMMODE"),
                COSINGED: true,
                Location: CookieService.getLocalStorageValues("Session_STATE") != null ? CookieService.getLocalStorageValues("Session_STATE") : "",
                ShipToID: CookieService.getLocalStorageValues("Session_TRUCK_USER") === "True" ? (CookieService.getLocalStorageValues("Session_TRUCK_STORAGE_AREA")) : CookieService.getLocalStorageValues("HOME_STORE") != null && CookieService.getLocalStorageValues("HOME_STORE") != undefined && CookieService.getLocalStorageValues("HOME_STORE") != "" ? CookieService.getLocalStorageValues("HOME_STORE") : " ",
                IsTrucUser: (CookieService.getLocalStorageValues("Session_TRUCK_USER") && CookieService.getLocalStorageValues("Session_TRUCK_USER").toLowerCase() == "true") || isFromFieldInventory,
                Truck_ShipTo: CookieService.getLocalStorageValues("Session_TRUCK_SHIPTO_ID"),
                truckIdData: TruckLocation,
                truckSearch: this.state.truckSearch
            }

            this.setState({ QTY: "" })
            $(`#${SDIConstants.SDILoader}`).removeClass('hide');
            STKIssuesCartAction.ItemSearchAction(BO);
        }

    }
    //WW-427
    AnykeyPress(e) {
        if (e.keyCode == 13) {
            ////;

            if ($("#NewItemID").val() != "") {

            }
            else {
                this.ItemSearch("");
            }

        }
    }
    handleSTKIssueYes = () => {
        DeleteFlag = true;
        proceed = false;
        $('#stkissuemixedcart').modal('hide');
        this.InsertInCart();
    }

    handleSTKIssueNo = () => {
        DeleteFlag = false;
        proceed = true;
        this.setState({ NewItemDetail: [], NewItemID: "", ItemCheck: false, ItemIdCheck: false, InvalidItemId: false, NewLocDetail: [], isButton: false, truckInPopup: false, QtyErrormsg: "", LabelChange: false, inputFieldShow: false });
        $('#stkissuemixedcart').modal('hide');
    }
    InsertInCart = () => {

        let loccart = [];
        let { cartArr } = this.state
        let cartlength = this.state.cartArr.length
        if (this.state.QTY == "") {
            this.setState({ QtyErrorMsg: "Please enter quantity" })
            return false
        }
        else if (parseInt(this.state.QTY) == 0) {
            this.setState({ InvalidItemId: true, QtyErrorMsg: "Please enter valid quantity" })
            return false
        }
        else if (this.state.TruckLocation != "") {
            if (parseInt(this.state.QTY) > parseInt(this.state.NewLocDetail.QuantityAvail)) {
                this.setState({ QtyErrorMsg: "Plese enter the quantity lesser than available" })
                return false
            }

            else {
                    if (cartArr.length > 0 ) {
                    $('#Add-New-Item').modal('hide');
                    const differentTruckId = cartArr.some(item => item.TruckLocation !== this.state.TruckLocation);
                    if (differentTruckId && proceed) {
                        $('#stkissuemixedcart').modal('show');
                        return;
                    }
                }
                let qty = this.state.NewLocDetail.QuantityAvail

                if (this.state.NewItemDetail.length > 0) {
                    if (cartArr.length > 0 ) {
                        $('#Add-New-Item').modal('hide');
                        const differentTruckId = cartArr.some(item => item.TruckLocation !== this.state.TruckLocation);
                        if (differentTruckId && proceed) {
                            $('#stkissuemixedcart').modal('show');
                            return;
                        }
                    }
                    let qty = this.state.NewLocDetail.QuantityAvail


                    let cart = {
                        ITEM_ID: this.state.NewItemDetail[0].ItemId,
                        DESCR254: this.state.NewItemDetail[0].DESCR254,
                        MFG: this.state.NewItemDetail[0].MFG,
                        MFGID: this.state.NewItemDetail[0].MFGID,
                        INV_ITEM_TYPE: this.state.NewItemDetail[0].INV_ITEM_TYPE,
                        UOM: this.state.NewItemDetail[0].UOM,
                        QtyAvailable: qty,
                        QUANTITY: this.state.QTY,
                        IMAGE_URL: this.state.NewItemDetail[0].ThumbnailImageFile,
                        QTYError: false,
                        VENDOR_ID: this.state.NewItemDetail[0].VendorID,
                        STORAGE_AREA: this.state.NewLocDetail.area ? this.state.NewLocDetail.area : "",
                        STOR_LEVEL_1: this.state.NewLocDetail.aisle ? this.state.NewLocDetail.aisle : "",
                        STOR_LEVEL_2: this.state.NewLocDetail.row ? this.state.NewLocDetail.row : "",
                        STOR_LEVEL_3: this.state.NewLocDetail.shelf ? this.state.NewLocDetail.shelf : "",
                        STOR_LEVEL_4: this.state.NewLocDetail.bin ? this.state.NewLocDetail.bin : "",
                        BUSINESS_UNIT: this.state.bu,
                        TruckLocation: this.state.TruckLocation,
                        ISA_EMPLOYEE_ID: isFromFieldInventory ? this.props.location.state.employee_id : CookieService.getLocalStorageValues("Session_UserID"),
                        ShipToID: CookieService.getLocalStorageValues("Session_TRUCK_USER") === "True" ? (isFromFieldInventory ? this.props.location.state.isa_truck_id : CookieService.getLocalStorageValues("Session_TRUCK_STORAGE_AREA")) : (CookieService.getLocalStorageValues("HOME_STORE") ? CookieService.getLocalStorageValues("HOME_STORE") : " "),
                        DeleteFlag: DeleteFlag ? "true" : "false",
                        SERIAL_ID: this.state.NewItemDetail[0].SERIAL_ID,
                        IsTrucUser: (CookieService.getLocalStorageValues("Session_TRUCK_USER") && CookieService.getLocalStorageValues("Session_TRUCK_USER").toLowerCase() == "true") || isFromFieldInventory,
                        ENTERED_BY: CookieService.getLocalStorageValues("Session_UserID") == "" || undefined || null ? "" : CookieService.getLocalStorageValues("Session_UserID"),
                        COSINGED: true,
                        Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
                        Session_SITEPREFIX: CookieService.getLocalStorageValues("Session_SITEPREFIX"),
                        Session_ITEMMODE: CookieService.getLocalStorageValues("Session_ITEMMODE"),
                    }
                    $(`#${SDIConstants.SDILoader}`).removeClass('hide');
                    STKIssuesCartAction.InsertAction(cart);
                    //loccart.push(cart)
                    cartArr[cartlength] = cart
                    this.setState({ NewItemID: "", isButton: false, ItemCheck: false, ItemIdCheck: false, Errormsg: "" })
                }

            }
        }
        else if (this.state.TruckLocation == "") {

            if (this.state.QTY > parseInt(this.state.NewItemDetail[0].QtyAvailable)) {
                this.setState({ QtyErrorMsg: "Plese enter the quantity lesser than available" })
                return false
            }
            else {

                if (this.state.NewItemDetail.length > 0) {
                    let qty = this.state.NewItemDetail[0].QtyAvailable
                    if (cartArr.length > 0 && this.state.TruckLocation != "") {
                        $('#Add-New-Item').modal('hide');
                        const differentTruckId = cartArr.some(item => item.TruckLocation !== this.state.TruckLocation);
                        if (differentTruckId && proceed) {
                            $('#stkissuemixedcart').modal('show');
                            return;
                        }
                    }

                    let cart = {
                        ITEM_ID: this.state.NewItemDetail[0].ItemId,
                        DESCR254: this.state.NewItemDetail[0].DESCR254,
                        MFG: this.state.NewItemDetail[0].MFG,
                        MFGID: this.state.NewItemDetail[0].MFGID,
                        INV_ITEM_TYPE: this.state.NewItemDetail[0].INV_ITEM_TYPE,
                        UOM: this.state.NewItemDetail[0].UOM,
                        QtyAvailable: qty,
                        QUANTITY: this.state.QTY,
                        IMAGE_URL: this.state.NewItemDetail[0].ThumbnailImageFile,
                        QTYError: false,
                        VENDOR_ID: this.state.NewItemDetail[0].VendorID,
                        STORAGE_AREA: this.state.NewLocDetail.area ? this.state.NewLocDetail.area : " ",
                        STOR_LEVEL_1: this.state.NewLocDetail.aisle ? this.state.NewLocDetail.aisle : " ",
                        STOR_LEVEL_2: this.state.NewLocDetail.row ? this.state.NewLocDetail.row : " ",
                        STOR_LEVEL_3: this.state.NewLocDetail.shelf ? this.state.NewLocDetail.shelf : " ",
                        STOR_LEVEL_4: this.state.NewLocDetail.bin ? this.state.NewLocDetail.bin : " ",
                        BUSINESS_UNIT: this.state.bu,
                        TruckLocation: this.state.TruckLocation,
                        ShipToID: CookieService.getLocalStorageValues("Session_TRUCK_USER") === "True" ? (isFromFieldInventory ? this.props.location.state.isa_truck_id : CookieService.getLocalStorageValues("Session_TRUCK_STORAGE_AREA")) : (CookieService.getLocalStorageValues("HOME_STORE") ? CookieService.getLocalStorageValues("HOME_STORE") : " "),
                        ISA_EMPLOYEE_ID: isFromFieldInventory ? this.props.location.state.employee_id : CookieService.getLocalStorageValues("Session_UserID"),
                        DeleteFlag: DeleteFlag ? "true" : "false",
                        SERIAL_ID: this.state.NewItemDetail[0].SERIAL_ID,
                        IsTrucUser: CookieService.getLocalStorageValues("Session_TRUCK_USER"),
                        ShipToID: CookieService.getLocalStorageValues("Session_TRUCK_USER") === "True" ? (isFromFieldInventory ? this.props.location.state.isa_truck_id : CookieService.getLocalStorageValues("Session_TRUCK_STORAGE_AREA")) : (CookieService.getLocalStorageValues("HOME_STORE") ? CookieService.getLocalStorageValues("HOME_STORE") : " "),
                        ENTERED_BY: CookieService.getLocalStorageValues("Session_UserID"),
                        COSINGED: true,
                        Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
                        Session_SITEPREFIX: CookieService.getLocalStorageValues("Session_SITEPREFIX"),
                        Session_ITEMMODE: CookieService.getLocalStorageValues("Session_ITEMMODE"),

                    }
                    $(`#${SDIConstants.SDILoader}`).removeClass('hide');
                    STKIssuesCartAction.InsertAction(cart);
                    cartArr[cartlength] = cart
                    this.setState({ NewItemID: "", isButton: false, ItemCheck: false, ItemIdCheck: false, Errormsg: "" })
                }

            }
        }

        this.setState({ cartArr });// NewItemDetail: [] 
        this.setState({ NewItemDetail: [] });
        $("#NewItemID").val('')
        console.log("cartArr", cartArr)

        CookieService.updateLocalStorageValues("STKCart", cartArr);
        CookieService.updateLocalStorageValues("TruckId", this.state.TruckOptions);

        $('#Add-New-Item').modal('hide');

    }
    //STKICC_PC_
    CloseButtonClick = () => {
        $('#Add-New-Item').modal('hide');
        $("#NewItemID").val('')
        this.setState({ NewItemDetail: [], NewItemID: "", ItemCheck: false, ItemIdCheck: false, InvalidItemId: false, NewLocDetail: [], isButton: false, truckInPopup: false, QtyErrormsg: "", LabelChange: false, inputFieldShow: false });
    }
    //STKICC_PC_
    ClearWO = () => {
        //CPW-220 Service Channel details not populated when using Stock Issue - Deepthi N H
        this.setState({ WONUM: "", ValidWO: false, SubmitButtonClick: false, WoStore: " ", WoPriority: " ", WoTrade: " " });
    }
    //STKICC_PC_11
    SubmitValidation = () => {
        if (isFromLink) {
            if (cribID == "") {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: "Please select crib for your profile in walmart site"
                });
                return
            }
        }
        let validation = false
        this.setState(() => {
            const newState = { SubmitButtonClick: true };
            return newState;
        });
        if (this.state.ValidWO && ((this.state.WONUM != "" && this.state.WONUM != undefined) || CookieService.getLocalStorageValues("Session_CARTWOREQ") == 'N') && (this.state.SelectedEmp.value != null && this.state.SelectedEmp.value != undefined && this.state.SelectedEmp.value != "") && this.state.cartArr.length > 0) {
            let qtycheck = true
            this.state.cartArr.forEach((item, index) => {
                console.log("Pa", (parseInt(item.QtyAvailable) < parseInt(item.Qty)) ? true : false)
                console.log("PaI", (parseInt(item.QtyAvailable)))
                if ((parseInt(item.QtyAvailable) < parseInt(item.Qty))) {
                    qtycheck = false
                    this.setState({ ERR: true, ErrStatement: item.ItemId + " quantity should be less than or equal to the available quantity" });
                    return true
                }
                if ((item.Qty == "" || item.Qty == null || item.Qty == undefined) || parseInt(item.Qty) == 0) {
                    qtycheck = false
                    //CPW-184 Stock Issue Panel Changes
                    this.setState({ ERR: true, ErrStatement: "Not all items have a quantity entered" });
                    return true
                }
            });
            if (qtycheck) {
                validation = true;
                this.setState({ ERR: false, ErrStatement: "" });
            }

        }
        if (validation) {
            this.setState({ SubmitButtonClick: true })
            this.Submit()
        }
        else {
            if (CookieService.getLocalStorageValues("Session_CARTWOREQ") != 'N' && (this.state.WONUM == "" || this.state.WONUM == null || this.state.WONUM == undefined)) {
                this.setState({ ERR: true, ErrStatement: "Please enter work order #", SubmitButtonClick: false });
                return;
            }
            if (this.state.ValidWO == false) {
                this.setState(() => {
                    const newState = {
                        SubmitButtonClick: true
                    };
                    return newState;
                }, () => {
                    this.WorkOrderInputCheck()
                });
                //this.setState({ ERR: true, ErrStatement: "Enter valid WO#" });
                return;
            }
            if (this.state.SelectedEmp.value == null || this.state.SelectedEmp.value == undefined || this.state.SelectedEmp.value == "") {
                this.setState({ ERR: true, ErrStatement: "Please select employee ID", SubmitButtonClick: false });
                return;
            }
        }

    }

    enterClick = (event) => {
        if (event.keyCode == 13) {
            this.WorkOrderInputCheck()
        }
    }

    //STKICC_PC_12
    Submit = () => {

        let STKCartItems = []
        console.log("WONUM", this.state.WONUM)
        console.log("cartArr", this.state.cartArr)
        let conditioncheck = false


        if (this.state.cartArr.length > 0) {
            this.state.cartArr.forEach((item, index) => {

                let arr = {
                    ItemId: item.ItemId,
                    Qty: item.Qty,
                    Price: item.Price,
                    Description: item.DESCR254,
                    UOM: item.UOM,
                    VendorId: item.VendorId,
                    MFG: item.MFG,
                    MFG_Part: item.MFGID,
                    ImageFile: item.ThumbnailImageFile == "" || item.ThumbnailImageFile == "\N" || item.ThumbnailImageFile == "\\N" || item.ThumbnailImageFile == null || item.ThumbnailImageFile == undefined ? "Images\noimage_new.png" : item.ThumbnailImageFile,
                    SelectedArea: item.SelectedArea != "" || item.SelectedArea != undefined || item.SelectedArea != null ? item.SelectedArea : "",
                    SelectedAisle: item.SelectedAisle != "" || item.SelectedAisle != undefined || item.SelectedAisle != null ? item.SelectedAisle : "",
                    SelectedRow: item.SelectedRow != "" || item.SelectedRow != undefined || item.SelectedRow != null ? item.SelectedRow : "",
                    SelectedShelf: item.SelectedShelf != "" || item.SelectedShelf != undefined || item.SelectedShelf != null ? item.SelectedShelf : "",
                    SelectedBin: item.SelectedBin != "" || item.SelectedBin != undefined || item.SelectedBin != null ? item.SelectedBin : ""
                }
                STKCartItems.push(arr)
            })

        }
        console.log("STKCartItems", STKCartItems)

        let BO = {
            Session_ID: CookieService.getLocalStorageValues("Session_ID"), //WW-390_PC_05 (4/20/2022)-Aparna
            SOURCE: "WEB",
            Session_UserID: CookieService.getLocalStorageValues("Session_UserID"),
            Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
            Session_MANORDNO: CookieService.getLocalStorageValues("Session_MANORDNO"),
            Session_ORDERPREFIX: CookieService.getLocalStorageValues("Session_ORDERPREFIX"),
            Session_SITEBU: CookieService.getLocalStorageValues("Session_SITEBU"),
            punchinSessionID: "",
            Session_USERTYPE: CookieService.getLocalStorageValues("Session_USERTYPE"),
            Session_EMAIL: CookieService.getLocalStorageValues("Session_EMAIL"),
            Session_SDIEMP: CookieService.getLocalStorageValues("Session_SDIEMP"),
            Session_UserName: CookieService.getLocalStorageValues("Session_USERNAME"),//***NEW**CHANGED(cookieservice)***(1/21/2021)**Session_UserName-->Session_USERNAME
            Session_TestMode: CookieService.getLocalStorageValues("Session_TESTMODE"),
            Session_WEBSITEID: CookieService.getLocalStorageValues("Session_WEBSITEID"),
            CurrentPage_Url: "/SDIXZEUS/ShoppingCart",
            Session_CplusDbSQL: CookieService.getLocalStorageValues("Session_CplusDbSQL"),
            Session_MobIssuing: CookieService.getLocalStorageValues("Session_MobIssuing"),
            Session_ITEMMODE: CookieService.getLocalStorageValues("Session_ITEMMODE"),
            Session_SITEPREFIX: CookieService.getLocalStorageValues("Session_SITEPREFIX"),
            Session_CARTFAIL: CookieService.getLocalStorageValues("Session_CARTFAIL"),
            Session_USESOLRSEARCH: CookieService.getLocalStorageValues("Session_USESOLRSEARCH"),
            Session_CplusDB: CookieService.getLocalStorageValues("Session_CplusDB"),
            Session_SDICAT: CookieService.getLocalStorageValues("Session_SDICAT"),
            Session_SEARCH3M: CookieService.getLocalStorageValues("Session_SEARCH3M"),
            Session_SEARCHORONASCO: CookieService.getLocalStorageValues("Session_SEARCHORONASCO"),
            Session_SEARCHCAPP: CookieService.getLocalStorageValues("Session_SEARCHCAPP"),
            Session_SEARCHMSC: CookieService.getLocalStorageValues("Session_SEARCHMSC"),
            Session_SEARCHIMP: CookieService.getLocalStorageValues("Session_SEARCHIMP"),
            Session_SEARCHSTAUFFER: CookieService.getLocalStorageValues("Session_SEARCHSTAUFFER"),
            Session_CARTTAXEXMPTFLAG: CookieService.getLocalStorageValues("Session_CARTTAXEXMPTFLAG"),
            Session_ISABudgetaryLimit: CookieService.getLocalStorageValues("Session_ISABudgetaryLimit"),
            Session_AGENTUSERID: CookieService.getLocalStorageValues("Session_AGENTUSERID"),
            Session_ValidateWorkOrder: CookieService.getLocalStorageValues("Session_ValidateWorkOrder"),
            Validation_Status: "True",
            chkLineNumFlag: "",
            Session_ShowPrice: CookieService.getLocalStorageValues("Session_ShowPrice"),
            Session_PHONE: CookieService.getLocalStorageValues("Session_PHONE"),
            Session_CONAME: CookieService.getLocalStorageValues("Session_CONAME"),
            Session_RFQSITE: CookieService.getLocalStorageValues("Session_RFQSite"),
            Session_ISACstVendor: CookieService.getLocalStorageValues("Session_ISACstVendor"),
            Session_ISACstPrice: CookieService.getLocalStorageValues("Session_ISACstPrice"),
            Session_CUSTID: CookieService.getLocalStorageValues("Session_CUSTID"),
            Order_WorkOrder: CookieService.getLocalStorageValues("Session_CARTWOREQ") == 'N' && this.state.WONUM == "" ? " " : this.state.WONUM,
            Order_Customer_Notes: this.state.CUST_NOTES,
            Order_EmployeeCC: this.state.SelectedEmp.value,
            Order_Type: "",
            Order_Customer_Reference: "",
            Order_ShipTo: CookieService.getLocalStorageValues("HOME_STORE") != null && CookieService.getLocalStorageValues("HOME_STORE") != undefined && CookieService.getLocalStorageValues("HOME_STORE") != "" ? CookieService.getLocalStorageValues("HOME_STORE") : " ",
            Location2: " ",
            //CPW-220 Service Channel details not populated when using Stock Issue - Deepthi N H
            USER_CHAR2: this.state.WoTrade != "" ? this.state.WoTrade : " ",
            ISA_USER2: this.state.WoStore != "" ? this.state.WoStore : " ",
            USER_CHAR1: this.state.WoPriority != "" ? this.state.WoPriority : " ",
            STKIssuesCartItems: STKCartItems,
            Crib: CookieService.getLocalStorageValues("Session_ISA_CRIB_IDENT"),//PC_743_07-Pass the user's crib
        }
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        STKIssuesCartAction.SubmitAction(BO);
    }
    //STKICC_PC_13
    SubmitResponse = () => {
        let Response = JSON.parse(STKIssuesCartStore.PageLoadData);
        console.log("Response", Response)
        if (Response != "") {
            $('#Order-Placed').modal('show');
            this.setState({ OrderNo: Response, ValidWO: false, WONUM: "", cartArr: [], CUST_NOTES: "", SubmitButtonClick: false });// cartArr: []
            CookieService.updateLocalStorageValues("STKCart", []);
        }
    }
    //STKICC_PC_14
    OrderPDF = () => {
        //CPW-184 Stock Issue Panel Changes
        $('#Order-Placed').modal('hide');
        //let cartFileBo = {
        //    Session_UserID: CookieService.getLocalStorageValues("Session_UserID"),
        //    Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
        //    OrderNO: this.state.OrderNo,//"NY00446489",
        //    fileName: ""
        //}
        //STKIssuesCartAction.OrderPdf(cartFileBo)
        //$(`#${SDIConstants.SDILoader}`).removeClass('hide');
    }
    //STKICC_PC_15
    OrderPDFShow = () => {
        OrderSuccessCOunt = OrderSuccessCOunt + 1
        let OrderPdf = STKIssuesCartStore.OrderPDFMsge;
        //if ((hidden == true || this.state.ShowPdf == true) && (this.state.base64URL != "" || OrderPdf != "")) {
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        $('#pdfPreview').modal('show');
        // }
        this.setState({ base64URL: OrderPdf })
        //let win = window.open("", "Title", "toolbar=no,location=no,directories=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=1005,height=500,top=" + (window.screen.height - 200) + ", left = " + (window.screen.width - 300));
        //
        //win.document.body.innerHTML = '<iframe width = "100%" height = "100%" src = "' + OrderPdf + '"></iframe>';
    }
    //STKICC_PC_16
    CancelOrder = () => {
        let DeleteBO = {
            ISA_EMPLOYEE_ID: CookieService.getLocalStorageValues("Session_UserID") == "" || undefined || null ? "" : CookieService.getLocalStorageValues("Session_UserID"),
            ITEM_ID: "",
            QUANTITY: 0,
            DeleteFlag: "true",
            IsTrucUser: CookieService.getLocalStorageValues("Session_TRUCK_USER"),
            ShipToID: CookieService.getLocalStorageValues("Session_TRUCK_USER") === "True" ? (CookieService.getLocalStorageValues("Session_TRUCK_STORAGE_AREA")) : (CookieService.getLocalStorageValues("HOME_STORE") ? CookieService.getLocalStorageValues("HOME_STORE") : " "),
            COSINGED: true,
            Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
            Session_SITEPREFIX: CookieService.getLocalStorageValues("Session_SITEPREFIX"),
            Session_ITEMMODE: CookieService.getLocalStorageValues("Session_ITEMMODE"),
        }
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        this.setState({ RemovePopup: false });
        STKIssuesCartAction.DeleteAction(DeleteBO);
        this.setState({ ErrStatement: "", ERR: false, WONUM: "", CUST_NOTES: "", RemovePopup: true });
    }

    CloseRemovePopup = () => {
        $('#Cancel-confirmation').modal('hide');
    }
    //onHandleAdjEdit = (e, index) => {
    //   // e.preventDefault()
    //    let Newindex = index

    //    $('#edit-adjustment-bin').modal('show');
    //    this.state.existTruck = this.state.cartArr[index].TruckLocation
    //    let ExistLocDetail = {
    //        area: this.state.cartArr[index].SelectedArea ,
    //        aisle: this.state.cartArr[index].SelectedAisle ,
    //        row: this.state.cartArr[index].SelectedRow ,
    //        shelf: this.state.cartArr[index].SelectedShelf ,
    //        bin: this.state.cartArr[index].SelectedBin ,
    //        QuantityAvail: this.state.cartArr[index].QtyAvailable,
    //    }

    //    //let EditLoc = this.state.LocDetails
    //    //let itemId = this.state.cartArr[index].ItemId

    //    this.setState({ index: Newindex, isNewPopup: true, opLoc: true, ErrorNew: "", qtyNew: this.state.QTY, isBin: true, existQty: this.state.cartArr[Newindex].QTY, ExistLocDetail: ExistLocDetail })
    //}

    saveClick = () => {
        let index = this.state.index
        if (this.state.cartArr[index].QTY == "") {
            this.setState({ QtyErrorMsg: "Please enter quantity" })
        }
        else if (parseInt(this.state.cartArr[index].QTY) == 0) {
            this.setState({ QtyErrorMsg: "Please enter valid quantity" })
        }
        else if (parseInt(this.state.cartArr[index].QTY) > parseInt(this.state.cartArr[index].QtyAvailable)) {
            this.setState({ QtyErrorMsg: "Quantity should be less than or equal to the available quantity" })
        }
        else {
            $('#edit-adjustment-bin').modal('hide');

            this.setState({ QtyErrorMsg: "", isBin: false, existQty: this.state.cartArr[index].QTY })
        }
        this.CloseButtonClick()
    }

    editCancel = () => {
        let i = this.state.index
        this.state.cartArr[i].QTY = this.state.existQty
        this.state.cartArr[i].TruckLocation = this.state.existTruck
        this.state.cartArr[i].SelectedArea = this.state.ExistLocDetail.area
        this.state.cartArr[i].SelectedAisle = this.state.ExistLocDetail.aisle
        this.state.cartArr[i].SelectedRow = this.state.ExistLocDetail.row
        this.state.cartArr[i].SelectedShelf = this.state.ExistLocDetail.shelf
        this.state.cartArr[i].SelectedBin = this.state.ExistLocDetail.bin
        this.state.cartArr[i].QtyAvailable = this.state.ExistLocDetail.QuantityAvail
        this.CloseButtonClick()
        this.setState({ QtyErrorMsg: "", ItemIdNew: "", ErrorNew: "", isBin: false, Errormsg: "", opLoc: false })
    }

    BindEditLocationMob = () => {
        let indexNew = this.state.index;
        this.state.IsLocSelected = true
        if (this.state.cartArr.length > 0) {
            return this.state.cartArr.map((val, index) => {
                if (indexNew == index) {
                    // let locArray = this.state.EditLoc.split(" ");
                    //let index = 0
                    let QTY = parseInt(val.QtyAvailable);

                    return (<React.Fragment key={index}>
                        <>

                            <tr>

                                <td data-toggle="collapse" data-target="#order-row-1" className="accordion-toggle collapsed"><span className="accordion-arrow accordion-arrow-change" /></td>
                                <td>{val.SelectedBU}</td>
                                <td>{QTY}</td>
                                <td>{QTY}</td>

                            </tr>
                            <tr className="p">
                                <td colSpan={5} className="hiddenRow border-bottom-0">
                                    <div className="accordian-body collapse py-1 border-bottom" id="order-row-1">
                                        <div className="px-3 py-2">
                                            <div className="row custom-bg pt-3">
                                                <div className="col-md-12 mb-3">
                                                    <span className="font-14 font-medium label-color">Serial ID :</span>
                                                    <span className="font-14 font-regular ml-1 label-value-color">None</span>
                                                </div>
                                                <div className="col-md-12 mb-3">
                                                    <span className="font-14 font-medium label-color">Area :</span>
                                                    <span className="font-14 font-regular ml-1 label-value-color">{val.SelectedArea}</span>
                                                </div>
                                                <div className="col-md-12 mb-3">
                                                    <span className="font-14 font-medium label-color">Aisle :</span>
                                                    <span className="font-14 font-regular ml-1 label-value-color">{val.SelectedAisle}</span>
                                                </div>
                                                <div className="col-md-12 mb-3">
                                                    <span className="font-14 font-medium label-color">Row :</span>
                                                    <span className="font-14 font-regular ml-1 label-value-color">{val.SelectedRow}</span>
                                                </div>
                                                <div className="col-md-12 mb-3">
                                                    <span className="font-14 font-medium label-color">Shelf :</span>
                                                    <span className="font-14 font-regular ml-1 label-value-color">{val.SelectedShelf}</span>
                                                </div>
                                                <div className="col-md-12 mb-3">
                                                    <span className="font-14 font-medium label-color">Bin :</span>
                                                    <span className="font-14 font-regular ml-1 label-value-color">{val.SelectedBin}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </td>
                            </tr>


                        </>

                    </React.Fragment>)

                }
            })
        }

    }

    BindEditLocation = () => {
        let indexNew = this.state.index;
        this.state.IsLocSelected = true
        // let locArray = this.state.EditLoc.split(" ");
        // let index = 0
        if (this.state.cartArr.length > 0) {
            return this.state.cartArr.map((val, index) => {
                if (indexNew == index) {
                    let QTY = parseInt(val.QtyAvailable);
                    return (<React.Fragment key={index}>
                        <>
                            <tr>

                                <td>{val.SelectedBU}</td>
                                <td>{QTY}</td>
                                <td>{val.SelectedArea}</td>
                                <td>{val.SelectedAilse}</td>
                                <td>{val.SelectedRow}</td>
                                <td>{val.SelectedShelf}</td>
                                <td>{val.SelectedBin}</td>
                            </tr>

                        </>

                    </React.Fragment>
                    )
                }
            })
        }

    }




    BindNewItemGridMobile = () => {
        let LocDetails = this.state.LocDetails;
        let index = 0;

        if (LocDetails && LocDetails.length > 0) {

            let locArray = LocDetails.split(" ");
            this.state.IsLocSelected = true
            return (<React.Fragment key={index}>
                <>
                    <tr className="mb-2">

                        <td data-toggle="collapse" data-target="#order-row-1" className="accordion-toggle collapsed"><span className="accordion-arrow accordion-arrow-change" /></td>
                        <td>{this.state.bu}</td>
                        <td>{parseInt(this.state.QtyDetails)}</td>
                        <td>{parseInt(this.state.QtyDetails)}</td>
                    </tr>
                    {/*row-1 ends here*/}
                    {/*accordion starts here*/}
                    <tr className="p">
                        <td colSpan={5} className="hiddenRow border-bottom-0">
                            <div className="accordian-body collapse py-1 border-bottom" id="order-row-1">
                                <div className="px-3 py-2">
                                    <div className="row custom-bg pt-3">
                                        <div className="col-md-12 mb-3">
                                            <span className="font-14 font-medium label-color">Serial ID :</span>
                                            <span className="font-14 font-regular ml-1 label-value-color">None</span>
                                        </div>
                                        <div className="col-md-12 mb-3">
                                            <span className="font-14 font-medium label-color">Area :</span>
                                            <span className="font-14 font-regular ml-1 label-value-color">{locArray[0]}</span>
                                        </div>
                                        <div className="col-md-12 mb-3">
                                            <span className="font-14 font-medium label-color">Aisle :</span>
                                            <span className="font-14 font-regular ml-1 label-value-color">{locArray[1]}</span>
                                        </div>
                                        <div className="col-md-12 mb-3">
                                            <span className="font-14 font-medium label-color">Row :</span>
                                            <span className="font-14 font-regular ml-1 label-value-color">{locArray[2]}</span>
                                        </div>
                                        <div className="col-md-12 mb-3">
                                            <span className="font-14 font-medium label-color">Shelf :</span>
                                            <span className="font-14 font-regular ml-1 label-value-color">{locArray[3]}</span>
                                        </div>
                                        <div className="col-md-12 mb-3">
                                            <span className="font-14 font-medium label-color">Bin :</span>
                                            <span className="font-14 font-regular ml-1 label-value-color">{locArray[4]}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </td>
                    </tr>
                </>

            </React.Fragment>)
        }
    }

    BindNewItemGrid = () => {
        let LocDetails = this.state.LocDetails;
        let index = 0;

        if (LocDetails && LocDetails.length > 0) {
            this.state.IsLocSelected = true
            let locArray = LocDetails.split(" ");

            return (
                <tr key={index} className="mb-2">

                    <td>{this.state.bu}</td>
                    <td>{parseInt(this.state.QtyDetails)}</td>
                    <td>{locArray[0]}</td>
                    <td>{locArray[1]}</td>
                    <td>{locArray[2]}</td>
                    <td>{locArray[3]}</td>
                    <td>{locArray[4]}</td>
                </tr>
            );

        } else {
            return null; // Return null or other fallback if LocDetails is empty or not an array
        }
    };



    //STK_PC_
    BindSTKCart = () => {
        const style = {
            image: {
                position: 'sticky',
                display: 'block',
                left: '0px !important',
                top: '0px !important',
            },
        }
        let RemoveKey = "  Remove"
        console.log("cartarr", this.state.cartArr)
        let cart = this.state.cartArr.length > 0 ? this.state.cartArr : CookieService.getLocalStorageValues("STKCart") != null && CookieService.getLocalStorageValues("STKCart") != undefined ? CookieService.getLocalStorageValues("STKCart") : []
        if (this.state.cartArr.length > 0) {
            return this.state.cartArr.map((val, index) => {
                //CPW-184 Stock Issue Panel Changes
                let QTY = parseInt(val.QtyAvailable);
                let quantity = QTY;
                const isQtyNull = quantity === null || quantity === undefined;
                const isMinQty = quantity <= 1;
                const isMaxQty = quantity >= QTY;


                return (
                    <div className="col-md-12">
                        <div className="row mx-0 mb-4 py-3 item-box">
                            <div className="col-md-12">
                                <div className="d-flex flex-wrap flex-lg-nowrap">
                                    <div className="image-resp-width">
                                        <Image
                                            id={`Img${val.Itemid}${index}id`}
                                            src={val.ThumbnailImageFile}
                                            width={120}
                                            height={130}
                                            style={style.image}
                                            noImageSrc="/Images/noimage_new.png"
                                        />
                                    </div>
                                    <div className="w-100">
                                        <div className="row">
                                            <div className="col-md-12 responsive-spacing-style">
                                                <div className="d-flex align-items-center justify-content-between mb-2 sm-stkissueqty">
                                                    <div style={{ width: "85%" }}>
                                                        <label className="font-12 font-regular label-value-color mb-0">{val.DESCR254}</label>
                                                    </div>
                                                    <div>
                                                        <div className="d-block sm-stkissueqty">
                                                            <div className="d-flex custom-product-add-cart justify-content-start justify-content-lg-end align-items-center">
                                                                <label className="font-12 font-medium label-color mb-0">Qty:</label>
                                                                <form id="myform" method="POST" class="quantity font-12" action="#">
                                                                    <input type="button" value="-" class="qtyminus minus" field="quantity" data-type="decrement" data-index={index} onClick={(e) => this.OnChangeField("QTY", e, index)} disabled={val.Qty<=1 } />
                                                                    <input
                                                                        type="text"
                                                                        name="quantity"
                                                                        value={val.Qty}
                                                                        class="qty noborderbin"
                                                                        data-type="enterqty"
                                                                        maxLength="5"
                                                                        id={"Quantity" + index}
                                                                        disabled={isQtyNull}
                                                                        data-index={index}
                                                                        onKeyDown={(e) => {
                                                                            if (e.key === 'Enter') {
                                                                                e.preventDefault();
                                                                            }
                                                                        }}
                                                                        onChange={(e) => this.OnChangeField("QTY", e, index)}
                                                                        onBlur={(e) => this.OnChangeField("QTY", e, index)}
                                                                        style={{ cursor: 'default' }}  // This removes the cursor pointer
                                                                    />
                                                                    <input type="button" value="+" class="qtyplus plus" field="quantity" data-type="increment" data-index={index} onClick={(e) => this.OnChangeField("QTY", e, index)} disabled={quantity === val.Qty || quantity <= val.Qty} />
                                                                </form>

                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-lg-3 col-md-12 mb-2">
                                                        <label className="font-12 font-medium label-color mb-0">Manufacturer part #:</label>
                                                        <label className="ml-2 font-12 font-regular label-value-color mb-0" id={`Item${val.MFGID}${index}id`}>{val.MFGID}</label>
                                                    </div>
                                                    <div className="col-lg-3 col-md-12 mb-2 custom-padding-none nowrap">
                                                        <label className="font-12 font-medium label-color mb-0">Manufacturer name:</label>
                                                        <label className="ml-2 font-12 font-regular label-value-color mb-0" id={`RFQ${val.Itemid}${val.MFG}id`}>{val.MFG}</label>
                                                    </div>

                                                    <div className="col-lg-3 col-md-12 mb-2">
                                                        <label className="font-12 font-medium label-color mb-0">UOM:</label>
                                                        <label className="ml-2 font-12 font-regular label-value-color mb-0" id={`Uom${val.Itemid}id`}>{val.UOM}</label>
                                                    </div>
                                                    <div className="col-lg-3 col-md-12 mb-2">
                                                        <label className="font-12 font-medium label-color mb-0">Supplier part #:</label>
                                                        <label className="ml-2 font-12 font-regular label-value-color mb-0" id={`Man${val.ItemId}${val.ItemId}id`}>{val.ItemId}</label>
                                                    </div>
                                                    <div className="col-lg-3 col-md-12 mb-2">
                                                        <label className="font-12 font-medium label-color mb-0">Type:</label>
                                                        <label className="ml-2 font-12 font-regular label-value-color mb-0" id={`Type${val.ItemId}${val.INV_ITEM_TYPE}id`}>{val.INV_ITEM_TYPE}</label>
                                                    </div>
                                                    {val.TruckLocation && val.TruckLocation != " " && val.TruckLocation != "" ?
                                                        <div className="col-lg-3 col-md-12 mb-2">
                                                            <label className="font-12 font-medium label-color mb-0">Truck or Rack ID:</label>
                                                            <label className="ml-2 font-12 font-regular label-value-color mb-0">{val.TruckLocation}</label>
                                                        </div> : null}
                                                    {val.TruckLocation && val.TruckLocation != " " && val.TruckLocation != "" ? <div className="col-lg-3 col-md-12 mb-2 custom-padding-none">
                                                        <label className="font-12 font-medium label-color mb-0">Bin location:</label>
                                                        <label className="ml-2 font-12 font-regular label-value-color mb-0" id={`loc${val.ItemId}id`}>{val.SelectedArea} {val.SelectedAisle} {val.SelectedRow} {val.SelectedShelf} {val.SelectedBin} {/*<a href="" data-toggle="modal" onClick={e => this.onHandleAdjEdit(e, index)} data-target="#edit-adjustment-bin"><img className="ml-2" src="images/edit-icon.svg" alt="edit" /></a> CPW-272[CR] - PC_CPW_272[CR]_01 - no need for this functionality.*/}</label>
                                                    </div> : null}
                                                    <div className="col-lg-3 col-md-12 mb-2">
                                                        <label className="font-12 font-medium label-color mb-0">Available qty:</label>
                                                        <label className="ml-2 font-12 font-regular label-value-color mb-0" id={`Type${val.ItemId}id`}>{QTY}</label>
                                                    </div>

                                                    <div className="col-md-12" style={{ cursor: "Pointer" }}>
                                                        <a href className="remove-order color-validation font-medium font-12" onClick={e => this.RemoveItem(index)} style={{ border: "none" }}><img src="Images/remove-order.svg" className="removeorder-icon mr-2 mb-1" alt="Remove Order" />Remove</a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>)
            });
        }
    }
    //STKICC_PC_
    BindNewItemDetail = () => {
        $('#savebuttonid').show();
        if (this.state.NewItemDetail.length > 0) {
            return (
                <>
                    {this.state.NewItemDetail[0].ZeroQty == "True" ?

                        (this.state.TruckLocation !== "" && this.state.truckInPopup ?
                            <div className="col-md-4 mb-3">
                                <label className="form-label catalog-label font-14 font-medium" htmlFor="truck-id">
                                    Truck or Rack ID<span className="color-manditory">*</span>
                                </label>
                                {this.state.cartArr.length > 0 || (CookieService.getLocalStorageValues("Session_TRUCK_USER") && CookieService.getLocalStorageValues("Session_TRUCK_USER").toLowerCase() == "false") ? (
                                    <label className="form-label catalog-label font-14 font-medium w-100" htmlFor="truck-id">
                                        {this.state.TruckLocation}
                                    </label>
                                ) : (
                                    <Select
                                        id="truck-id"
                                        name="TruckData"
                                        onChange={(e) => this.handleTruckDDChange(e)}
                                        value={{ value: this.state.TruckLocation, label: this.state.TruckLocation }}
                                        options={this.state.TruckOptions}
                                    />
                                )}
                            </div> : null) :

                        (this.state.NewItemDetail[0].ItemId != null ?
                            <div className="modal-body">
                                <div className="row">
                                    <div className="col-md-12">
                                        <h5 className="font-bold font-16">Item details</h5>
                                    </div>

                                    <div className="col-md-4 col-sm-6 mb-3">
                                        <label className="font-14 font-medium w-100 mb-2 color-dark-black">Manufacturer part #</label>
                                        <label className="font-14 font-regulars w-100 mb-0 color-light-black">
                                            {this.state.NewItemDetail[0].MFGID === "" ? "-" : this.state.NewItemDetail[0].MFGID}
                                        </label>
                                    </div>
                                    <div className="col-md-4 col-sm-6 mb-3">
                                        <label className="font-14 font-medium w-100 mb-2 color-dark-black">Manufacturer name</label>
                                        <label className="font-14 font-regulars w-100 mb-0 color-light-black">
                                            {this.state.NewItemDetail[0].MFG}
                                        </label>
                                    </div>
                                    <div className="col-md-4 col-sm-6 mb-3">
                                        <label className="font-14 font-medium w-100 mb-2 color-dark-black">Description</label>
                                        <label className="font-14 font-regulars w-100 mb-0 color-light-black">
                                            {this.state.NewItemDetail[0].DESCR254 === "" ? "-" : this.state.NewItemDetail[0].DESCR254}
                                        </label>
                                    </div>
                                    <div className="col-md-4 col-sm-6 mb-3">
                                        <label className="font-14 font-medium w-100 mb-2 color-dark-black">Supplier part #</label>
                                        <label className="font-14 font-regulars w-100 mb-0 color-light-black">
                                            {this.state.NewItemDetail[0].ItemId}
                                        </label>
                                    </div>
                                    <div className="col-md-4 col-sm-6 mb-3">
                                        <label className="font-14 font-medium w-100 mb-2 color-dark-black">Serial ID</label>
                                        <label className="font-14 font-regulars w-100 mb-0 color-light-black">{this.state.NewItemDetail[0].SERIAL_ID}
                                        </label>
                                    </div>

                                    <div className="col-md-4 col-sm-6 mb-3">
                                        <label className="font-14 font-medium w-100 mb-2 color-dark-black">Type</label>
                                        <label className="font-14 font-regulars w-100 mb-0 color-light-black">
                                            {this.state.NewItemDetail[0].INV_ITEM_TYPE}
                                        </label>
                                    </div>
                                    <div className="col-md-4 col-sm-6 mb-3">
                                        <label className="font-14 font-medium w-100 mb-2 color-dark-black">UOM</label>
                                        <label className="font-14 font-regulars w-100 mb-0 color-light-black">
                                            {this.state.NewItemDetail[0].UOM}
                                        </label>
                                    </div>
                                    {this.state.TruckLocation === "" && (
                                        <div className="col-md-4 col-sm-6 mb-3">
                                            <label className="font-14 font-medium w-100 mb-2 color-dark-black">Qty available</label>
                                            <label className="font-14 font-regulars w-100 mb-0 color-light-black">
                                                {this.state.NewItemDetail[0].QtyAvailable}
                                            </label>
                                        </div>
                                    )}
                                    {this.state.TruckLocation !== "" && this.state.truckInPopup && (
                                        <div className="col-md-4 mb-3">
                                            <label className="form-label catalog-label font-14 font-medium" htmlFor="truck-id">
                                                Truck or Rack ID<span className="color-manditory">*</span>
                                            </label>
                                            {this.state.cartArr.length > 0 || (CookieService.getLocalStorageValues("Session_TRUCK_USER") && CookieService.getLocalStorageValues("Session_TRUCK_USER").toLowerCase() == "false" || this.state.LabelChange ) ? (
                                                <label className="form-label catalog-label font-14 font-medium w-100" htmlFor="truck-id">
                                                    {this.state.TruckLocation}
                                                </label>
                                            ) : (
                                                <Select
                                                    className={"dd-bind"}
                                                    id="truck-id"
                                                    name="TruckData"
                                                    onChange={(e) => this.handleTruckDDChange(e)}
                                                    value={{ value: this.state.TruckLocation, label: this.state.TruckLocation }}
                                                    options={this.state.TruckOptions}
                                                />
                                            )}

                                        </div>
                                    )}
                                    <div className="col-md-4 mb-3">
                                        <label className="form-label catalog-label text-nowrap" htmlFor="quantity">
                                            Quantity to issue<span className="color-validation">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="quantity"
                                            maxLength="5"
                                            value={this.state.QTY}
                                            onChange={(e) => this.OnChangeField("QTY2", e, "")}
                                            placeholder="Enter quantity"
                                        />
                                        {this.state.QtyErrorMsg !== "" && (
                                            <span className="font-12 font-regular color-validation">{this.state.QtyErrorMsg}</span>
                                        )}
                                    </div>
                                </div>


                                {(this.state.TruckLocation !== "" && this.state.truckInPopup) ?
                                    <div className="col-md-12 mt-1">
                                        <h5 className="font-bold font-16 mb-3">Location details</h5>
                                        {isFromLink ?
                                            < div className="table-responsive mt-2 custom-displayNew popup-grid-scroll-style">
                                                <table className="table ZEUS_Grid FOM-grid mobileresponsive-grid mb-0">
                                                    <thead className="">
                                                        <tr>

                                                            <th>BU</th>
                                                            <th>Qty available</th>
                                                            <th>Qty</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>{this.BindNewItemGridMobile()}</tbody>
                                                </table>
                                            </div> :

                                            <div className="table-responsive popup-grid-scroll-style">
                                                <table className="table split-delv-table mb-0">
                                                    <thead className="">
                                                        <tr>

                                                            <th>BU</th>
                                                            <th>Qty available</th>
                                                            <th>Area</th>
                                                            <th>Aisle</th>
                                                            <th>Row</th>
                                                            <th>Shelf</th>
                                                            <th>Bin</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>{this.BindNewItemGrid()}</tbody>
                                                </table>
                                            </div>}
                                    </div> : null}
                            </div>

                            : null)}
                </>
            );
        }
    };


    //WW-427_PC
    removeSpace = (e) => {
        $("#NewItemID").val((e.target.value).trim());
        //console.log(val);
    }

    ClearItemId = () => {
        this.setState({ NewItemID: "", ItemCheck: false, ItemIdCheck: false, NewItemDetail: [], InvalidItemId: false, NewLocDetail: [], LocDetails: [], QtyErrorMsg: "", qtyInPopup: false, isButton: false, truckInPopup: false, QtyErrormsg: "" })
    }
    navigateToFieldInventory = () => {
        this.props.history.push('/FieldInventoryWorkbench');
    };
    NAItems = () => {
        if (!this.state.unavailableItems || this.state.unavailableItems.length === 0) {
            return null;
        }

        return this.state.unavailableItems.map((item, index) => (
            <div key={index}>
                <p>{item.ItemId} - {item.DESCR254}</p>
            </div>
        ));
    }
    QTYNA = (action) => {
        if (action === "1") {
            // Remove these items
            let UnAvaialableList = this.state.unavailableItems.map(item => item.ItemId);
            let DeleteUnAvailableObj = {
                UserID: CookieService.getLocalStorageValues("Session_UserID"),
                ShipTo: CookieService.getLocalStorageValues("HOME_STORE"),
                UnAvailableList: UnAvaialableList,
                IsTrucUser: (CookieService.getLocalStorageValues("Session_TRUCK_USER") && CookieService.getLocalStorageValues("Session_TRUCK_USER").toLowerCase() == "true") || isFromFieldInventory,
                ShipToID: CookieService.getLocalStorageValues("Session_TRUCK_USER") === "True" ? (CookieService.getLocalStorageValues("Session_TRUCK_STORAGE_AREA")) : (CookieService.getLocalStorageValues("HOME_STORE") ? CookieService.getLocalStorageValues("HOME_STORE") : " "),
                COSINGED: true,
                Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
                Session_SITEPREFIX: CookieService.getLocalStorageValues("Session_SITEPREFIX"),
                Session_ITEMMODE: CookieService.getLocalStorageValues("Session_ITEMMODE"),

            };
            $(`#${SDIConstants.SDILoader}`).removeClass('hide');
            STKIssuesCartAction.DeleteUnavailableItems(DeleteUnAvailableObj);
        } else if (action === "2") {
            // Apply Change
            $('#QTY-popup').modal('hide');
        }
    }
    //STKICC_PC_17
    render() {
        const { t } = this.props;

        return (
            <div className={"container-fluid container-margin content-section"} style={isFromLink ? { marginTop: "10px" } : {}}>
                <div className="row">
                    {/*Page Heading starts here*/}
                    <div className="col-md-12 mt-3 mb-4 page-heading">
                        <h5 className="page-title">{this.state.isFromFieldInventory ? (
                            <span className="table-sort mr-2" onClick={this.navigateToFieldInventory}>
                                <img src="images/left-arrow.svg" alt="sort-up" />
                            </span>
                        ) : null}Stock Issue</h5>
                        {/*{!isFromLink ? <div className="fav-item-maintenance-icon mt-1">*/}
                        {/*    <input type="checkbox" id="checkbox-OrdStatus" className="checknow" name="isFavorited" checked={this.state.isFavorited} onChange={this.handleFavorite} />*/}
                        {/*    <label htmlFor="checkbox-OrdStatus">*/}
                        {/*        <svg className="heart-svg" viewBox="467 392 58 57" xmlns="http://www.w3.org/2000/svg">*/}
                        {/*            <g className="Group" fill="none" fillRule="evenodd" transform="translate(467 392)">*/}
                        {/*                <path d="M29.144 20.773c-.063-.13-4.227-8.67-11.44-2.59C7.63 28.795 28.94 43.256 29.143 43.394c.204-.138 21.513-14.6 11.44-25.213-7.214-6.08-11.377 2.46-11.44 2.59z" className="heart" fill="#fff" />*/}
                        {/*                <circle className="main-circ" fill="#E2264D" opacity={0} cx="29.5" cy="29.5" r="1.5" />*/}
                        {/*                <g className="grp7" opacity={0} transform="translate(7 6)">*/}
                        {/*                    <circle className="oval1" fill="#9CD8C3" cx={2} cy={6} r={2} />*/}
                        {/*                    <circle className="oval2" fill="#8CE8C3" cx={5} cy={2} r={2} />*/}
                        {/*                </g>*/}
                        {/*                <g className="grp6" opacity={0} transform="translate(0 28)">*/}
                        {/*                    <circle className="oval1" fill="#CC8EF5" cx={2} cy={7} r={2} />*/}
                        {/*                    <circle className="oval2" fill="#91D2FA" cx={3} cy={2} r={2} />*/}
                        {/*                </g>*/}
                        {/*                <g className="grp3" opacity={0} transform="translate(52 28)">*/}
                        {/*                    <circle className="oval2" fill="#9CD8C3" cx={2} cy={7} r={2} />*/}
                        {/*                    <circle className="oval1" fill="#8CE8C3" cx={4} cy={2} r={2} />*/}
                        {/*                </g>*/}
                        {/*                <g className="grp2" opacity={0} transform="translate(44 6)">*/}
                        {/*                    <circle className="oval2" fill="#CC8EF5" cx={5} cy={6} r={2} />*/}
                        {/*                    <circle className="oval1" fill="#CC8EF5" cx={2} cy={2} r={2} />*/}
                        {/*                </g>*/}
                        {/*                <g className="grp5" opacity={0} transform="translate(14 50)">*/}
                        {/*                    <circle className="oval1" fill="#91D2FA" cx={6} cy={5} r={2} />*/}
                        {/*                    <circle className="oval2" fill="#91D2FA" cx={2} cy={2} r={2} />*/}
                        {/*                </g>*/}
                        {/*                <g className="grp4" opacity={0} transform="translate(35 50)">*/}
                        {/*                    <circle className="oval1" fill="#F48EA7" cx={6} cy={5} r={2} />*/}
                        {/*                    <circle className="oval2" fill="#F48EA7" cx={2} cy={2} r={2} />*/}
                        {/*                </g>*/}
                        {/*                <g className="grp1" opacity={0} transform="translate(24)">*/}
                        {/*                    <circle className="oval1" fill="#9FC7FA" cx="2.5" cy={3} r={2} />*/}
                        {/*                    <circle className="oval2" fill="#9FC7FA" cx="7.5" cy={2} r={2} />*/}
                        {/*                </g>*/}
                        {/*            </g>*/}
                        {/*        </svg>*/}
                        {/*    </label>*/}
                        {/*</div> : null}*/}
                    </div>
                    {/*Page Heading ends here*/}
                    <div className="col-md-12">
                        <div className="row">
                            {/*form starts here*/}
                            <div className="col-md-3">
                                <label className="form-label catalog-label" htmlFor="work-order">Work order #{CookieService.getLocalStorageValues("Session_CARTWOREQ") != 'N' ? <span className="color-validation">*</span> : <span></span>}</label>
                                <div className="position-relative">
                                    {isFromLink == true ? <input type="text" className="form-control charge-code-control" placeholder="Enter work order #" id="OLWorkOrderTB" maxLength="9" min="0" max="9" step="1" inputmode="numeric" value={this.state.WONUM} onChange={e => this.OnChangeField("WO", e)} defaultValue={''} onKeyDown={this.enterClick} /> : <input type="text" className="form-control charge-code-control" placeholder="Enter work order #" id="OLWorkOrderTB" maxLength="9" value={this.state.WONUM} onChange={e => this.OnChangeField("WO", e)} defaultValue={''} onKeyDown={this.enterClick} />}
                                    {this.state.WONUM != undefined && this.state.WONUM != null && this.state.WONUM != "" && this.state.WONUM != " " ?
                                        <span className="search-cancel-header cursor-pointer position-absolute" style={{ right: "25px", top: "48px" }} onClick={() => this.ClearWO()} > </span> : null
                                    }
                                    <span className="dropdown-search-icon-man position-absolute" style={{ right: "8px", top: "46px" }} onClick={(e) => this.WorkOrderInputCheck(e)} img src="images/search-icon.svg" alt="search-icon" />
                                </div>
                                {
                                    this.state.ValidWO && CookieService.getLocalStorageValues("Session_CC_VALIDATE_WO") != 'N' && (
                                        <div className="col-md-12 px-lg-0 mb-2 py-2 d-flex align-items-center">
                                            <div className="stock-issue-logo-container justify-content-center d-flex">
                                                <img src="images/logo.svg" alt="" className="w-100" />
                                            </div>
                                            <div className="ml-3">
                                                <div>
                                                    <label className="font-12 mb-1 app-enhancements-main-content">Work order store :</label>
                                                    <p className="font-14 m-0 app-enhancements-sub-content">{this.state.WoStore}</p>
                                                </div>
                                                <div>
                                                    <label className="font-12 mb-1 app-enhancements-main-content">Work order trade :</label>
                                                    <p className="font-14 m-0 app-enhancements-sub-content">{this.state.WoTrade}</p>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                }
                                {this.state.ERR && this.state.ErrStatement.includes("#") ? <span className="W-100 errorspan1StockIsuue text-left mt-1" style={{ fontSize: '15px' }}>{this.state.ErrStatement}</span> : null}
                            </div>
                            <div className="col-md-3 mb-2">
                                <label className="form-label catalog-label w-100" id="OLEmplyIdLabel" htmlFor="employee-id">Employee ID<span className="color-validation">*</span></label>
                                <Select
                                    id="EmpDDid"
                                    name="EmpDD"
                                    onChange={(e) => this.OnChangeField("Emp", e)}
                                    value={this.state.SelectedEmp}
                                    options={this.state.EmpDD}
                                    placeholder={"Select"}
                                    defaultValue={this.state.default}
                                    isDisabled={true}
                                    style={{ top: "37px" }}
                                />
                            </div>
                            <div className="col-md-3 mb-2">
                                <label className="form-label catalog-label" htmlFor="customer-notes">Customer notes</label>
                                <textarea className="form-control" maxLength="254" id="CusNotes" value={this.state.CUST_NOTES} placeholder="Enter notes" onChange={(e) => this.OnChangeField("CUST_NOTES", e)} rows={1} defaultValue={""} />
                            </div>
                        </div>

                        {/*form ends here*/}
                        {/*Item details starts here*/}
                        <div className="col-md-12 mb-3">
                            <div className="d-flex justify-content-between align-items-center">
                                <h5 className="font-bold font-16 mb-0">Item details</h5>
                                {this.state.cartArr.length > 0 || (CookieService.getLocalStorageValues("Session_TRUCK_USER") && CookieService.getLocalStorageValues("Session_TRUCK_USER").toLowerCase() == "true") ?
                                    <div>
                                        <div className="d-flex justify-content-between align-items-center">
                                            <div>
                                                <button className="btn btn-custom-primary font-14 font-medium px-4" data-toggle="modal" data-target="#Add-New-Item" data-backdrop="static" data-keyboard="false"><img className="mr-2" src="images/add-icon.svg" alt="add-icon" />Add new item</button>
                                            </div>
                                            <div className="custom-border-left ml-3">
                                                <a href="#" data-toggle="modal" data-target="#QR_Scanner_ManualPopup" data-backdrop="static" data-keyboard="false" onClick={(e) => this.handleOpenQR(e, "2")}> <img className="ml-3" src="images/qr-code.svg" alt="qr-code" /></a>
                                            </div>
                                        </div>
                                    </div>
                                    : null}
                            </div>
                        </div>
                        {this.state.cartArr.length > 0 ?
                            this.BindSTKCart()
                            : <div className="text-center mt-5 mb-2">
                                <img className="mb-4" src="images/no-items-added-img.svg" alt="no-items-added" />
                                <label className="font-14 font-medium text-label-color w-100">You have no items added to the stock issue cart.</label>
                            </div>
                        }


                        {this.state.ERR && !this.state.ErrStatement.includes("#") ? <p className="W-100 errorspan2 mx-0 mb-2 marginLeft mr-4" style={{ fontSize: '15px' }}>{this.state.ErrStatement}</p> : null}
                        {this.state.cartArr.length > 0 ?
                            <div className="col-md-12 mb-3">
                                <div className="d-flex justify-content-end">
                                    <button className="btn btn-dark-grey  font-14 font-medium mr-3 px-4" data-toggle="modal" data-target="#Cancel-btn" data-backdrop="static" data-keyboard="false">Cancel order</button>
                                    <button className="btn btn-custom-primary font-14 font-medium px-4" data-backdrop="static" data-keyboard="false" onClick={() => this.SubmitValidation()} >Submit order</button>
                                </div>
                            </div> : null}
                    </div>
                </div>

                <div className="modal fade Add-New-Item p-0" id="Add-New-Item" tabIndex={-1} role="dialog" aria-hidden="true" data-backdrop="static" style={{ overflow: 'auto' }}>
                    <div className={this.state.NewItemDetail.length > 0 && this.state.NewItemDetail[0].ItemId ? "modal-dialog modal-dialog-centered custom-add-new-item-width" : "modal-dialog modal-dialog-centered"} role="document">
                        <div className="modal-content border-0">
                            <div className="modal-header sp-delv-header align-items-center">
                                <h5 className="modal-title" id="exampleModalLongTitle">Add new item</h5>
                                <button type="button" className="btn-close" data-dismiss="modal" onClick={e => this.CloseButtonClick()} aria-label="Close"><img src="images/close-icon.svg" alt="close" /></button>
                            </div>
                            {/*Body Starts here*/}
                            <div className="modal-body dropdown-overlay">
                                <div className="row">
                                    <div className={this.state.NewItemDetail.length > 0 && this.state.NewItemDetail[0].ItemId ? "col-md-4" : "col-md-8"}>
                                        <div className="d-flex align-items-end">
                                            {!this.state.inputFieldShow && (<div className="d-block w-100">
                                                <label className="form-label catalog-label text-nowrap" htmlFor="part-itemid">Supplier part #/Item ID <span className="color-validation">*</span></label>
                                                <input type="text" className="form-control" maxLength="18" name="NewItemID" id="NewItemID" value={this.state.NewItemID} onChange={(e) => this.OnChangeField("ItemId", e)} onKeyDown={this.keyPress} placeholder="Enter supplier part#/Item ID" />
                                                {this.state.NewItemID != undefined && this.state.NewItemID != null && this.state.NewItemID != "" && this.state.NewItemID != " " ?
                                                    <span class="search-cancel-header cursor-pointer position-absolute" style={{ right: "94px", top: "48px" }} onClick={() => this.ClearItemId()} > </span> : null
                                                }
                                                <span className="dropdown-search-icon-man position-absolute" style={{ right: "78px", top: "48px" }} onClick={() => this.ItemSearch("")} img src="images/search-icon.svg" alt="search-icon" />
                                            </div>)}
                                            {!this.state.inputFieldShow && (<div className="">
                                                <a href="">
                                                    <a href="#" data-toggle="modal" data-target="#QR_Scanner_ManualPopup" data-backdrop="static" data-keyboard="false" onClick={(e) => this.handleOpenQR(e, "2")}> <img className="ml-3" src="images/qr-code.svg" alt="qr-code" /></a>
                                                </a>
                                            </div>)}
                                        </div>

                                    </div>
                                    {this.state.ItemCheck ? <span className=" W-100 errorspan1 text-left mx-3 mt-2" style={{ fontSize: '15px' }}>The item is already in the cart</span> : null}
                                    {this.state.ItemIdCheck ? <span className=" W-100 errorspan1 text-left mx-3 mt-2" style={{ fontSize: '15px' }}>Please enter item ID</span> : null}
                                    {this.state.InvalidItemId ? <span className=" W-100 errorspan1 text-left mx-3 mt-2" style={{ fontSize: '15px' }}>{this.state.Errormsg}</span> : null}

                                </div>
                                {this.BindNewItemDetail()}
                            </div>
                            {/*Body ends here*/}
                            {/*button*/}
                            {this.state.isButton == true ?
                                <div className="modal-footer border-0 mt-3 mb-2 justify-content-end">
                                    <button className="btn btn-dark-grey font-14 font-medium mr-3 px-4" data-dismiss="modal" onClick={() => this.CloseButtonClick()}>Cancel</button>
                                    <button className="btn btn-custom-primary font-14 font-medium px-4" disabled={(this.state.ItemCheck || this.state.ItemIdCheck || this.state.InvalidItemId) ? true : false} onClick={() => this.InsertInCart()}>Add to cart</button>
                                </div> : null}
                            {/*button*/}
                        </div>

                    </div>
                </div>

                <div className="modal pr-0" id="Cancel-confirmation" data-backdrop="static" data-keyboard="false">

                    <div className="modal-dialog modal-md custom-popup modal-dialog-centered">
                        <div className="modal-content">
                            {/* Modal Header */}
                            <div className="modal-header">
                                <h4 className="modal-title mt-1" />
                                <button type="button" className="btn close-btn" onClick={(e) => this.CloseRemovePopup(e)} data-dismiss="modal">
                                    X</button>
                            </div>
                            {/* Modal body */}
                            <div className="modal-body">
                                <div className="row text-center">
                                    <div className="col-md-12 my-4">
                                        <span className="question-mark-icon delete-confirm-icon" />
                                    </div>
                                    <div className="col-12 mb-4">
                                        <label className="confirm-label d-block"><Trans>Confirm</Trans></label>
                                        <label className="confirm-content d-block"><Trans>Do you want to remove this item ?</Trans></label>
                                    </div>
                                    <div className="col-md-12 text-center mb-2">
                                        <button className="btn btn-secondary custom-btn-secondary secondary-btn mr-3 px-5" data-dismiss="modal" onClick={(e) => this.CloseRemovePopup(e)}><Trans>No</Trans></button>
                                        <button className="btn btn-primary custom-btn-primary primary-btn px-5" data-dismiss="modal" onClick={(e) => this.OnChangeField("Remove", e, this.state.RemoveIndex)}  ><Trans>Yes</Trans></button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

                <div className="modal" id="Order-Placed" data-backdrop="static" data-keyboard="false">
                    <div className="modal-dialog modal-md custom-popup modal-dialog-centered">
                        <div className="modal-content">
                            {/* Modal Header */}
                            <div className="modal-header">
                                <h4 className="modal-title mt-1" />
                                {/*<button type="button" className="btn close-btn" data-dismiss="modal" onClick={() => this.OrderPlaced()}>
                        X
  </button>*/}
                            </div>
                            {/* Modal body */}
                            <div className="modal-body">
                                <div className="row text-center">
                                    <div className="col-md-12 my-4">
                                        <span className="question-mark-icon success-alert-icon" />
                                    </div>
                                    <div className="col-12 mb-4">
                                        <label className="confirm-label d-block"><Trans>Order completed, please take your items</Trans></label>
                                        <label className="confirm-content d-block"></label>
                                        <label className="confirm-label d-block"><Trans>Order</Trans><span> </span><Trans>No</Trans><span>:</span><span className="mx-2">{this.state.OrderNo}</span></label>
                                    </div>
                                    <div className="col-md-12 text-center mb-2">
                                        <button className="btn btn-primary custom-btn-primary primary-btn px-5" data-dismiss="modal" onClick={e => this.OrderPDF()} ><Trans>OK</Trans></button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


                <div className="modal" id="Cancel-btn">
                    <div className="modal-dialog modal-md custom-popup modal-dialog-centered">
                        <div className="modal-content">
                            {/* Modal Header */}
                            <div className="modal-header">
                                <h4 className="modal-title mt-1" />
                                <button type="button" className="btn close-btn" data-dismiss="modal">
                                    X
                                </button>
                            </div>
                            {/* Modal body */}
                            <div className="modal-body">
                                <div className="row text-center">
                                    <div className="col-md-12 my-4">
                                        <span className="question-mark-icon delete-confirm-icon" />
                                    </div>
                                    <div className="col-12 mb-4">
                                        <label className="confirm-label d-block"><Trans>Confirm</Trans></label>
                                        <label className="confirm-content d-block"><Trans>Are you sure you want to cancel your order?</Trans></label>
                                    </div>
                                    <div className="col-md-12 text-center mb-2">
                                        <button className="btn btn-secondary custom-btn-secondary secondary-btn mr-3 px-5" data-dismiss="modal"><Trans>No</Trans></button>
                                        <button className="btn btn-primary custom-btn-primary primary-btn px-5" data-dismiss="modal" onClick={(e) => this.CancelOrder()}><Trans>Yes</Trans></button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="modal fade qr-scan" tabIndex={-1} role="dialog" aria-hidden="true" id="QR_Scanner_ManualPopup">
                    <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
                        <div className="modal-content border-0">
                            <div className="modal-header sp-delv-header align-items-center">
                                <h5 className="modal-title" id="exampleModalLongTitle">QR scan</h5>
                                <button type="button" className="btn-close" data-dismiss="modal" aria-label="Close" onClick={() => this.handleCloseQR()}><img src="images/close-icon.svg" alt="close" /></button>
                            </div>
                            {/*QR Starts here*/}
                            <div className="modal-body text-center my-4 overflow-hidden">
                                <div className="row mt-3">
                                    <div className="col-12 text-center  mb-4">
                                        {this.state.QRError == true ?
                                            <><img className="mt-2" src="images/camera-open-img.svg" alt="qr-code-camera" />
                                                <p className="mb-1 font-18 mt-5 font-medium color-light-black"><Trans>Please allow your browser to access your webcam</Trans></p>
                                                <div className="modal-footer border-0 d-flex justify-content-center pt-1">
                                                    <button className="btn btn-custom-primary font-15 font-medium mr-2 mb-2 px-4 py-2" data-dismiss="modal" onClick={() => this.handleCloseQR()}><Trans>OK</Trans></button>
                                                </div>
                                            </> :
                                            this.state.QR == true ?
                                                <BarcodeScannerComponent
                                                    width="100%"
                                                    height={500}
                                                    onUpdate={this.handleQRScan}
                                                    facingMode={"environment"}
                                                    onError={this.handleQRScanError}

                                                /> : null
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/*QR ends here*/}
                    </div>
                </div>



                {/*Modal Starts here*/}
                {this.state.isBin ?
                    <div className="modal fade bin-location-popup" tabIndex={-1} role="dialog" aria-hidden="true" id="edit-adjustment-bin">
                        <div className="modal-dialog custom-bin-location-width modal-dialog-centered" role="document">
                            <div className="modal-content border-0">
                                <div className="modal-header sp-delv-header align-items-center">
                                    <h5 className="modal-title" id="exampleModalLongTitle">Bin location</h5>
                                    <button type="button" className="btn-close" data-dismiss="modal" aria-label="Close"><img src="images/close-icon.svg" alt="close" onClick={() => this.editCancel()} /></button>
                                </div>
                                <div className="modal-body dropdown-overlay">
                                    <div className="row">
                                        <div className="col-md-6 ">
                                            <label className="form-label catalog-label font-14 font-medium" htmlFor="truck-id">Truck or Rack ID<span className="color-manditory">*</span></label>
                                            <Select
                                                id="truck-id"
                                                name="TruckData"
                                                onChange={(e) => this.handleTruckDDChange(e)}
                                                value={{ value: this.state.cartArr[this.state.index].TruckLocation, label: this.state.cartArr[this.state.index].TruckLocation }}
                                                options={this.state.TruckOptions}
                                            />
                                        </div>

                                        <div className="col-md-6 ">
                                            <label className="form-label catalog-label text-nowrap" htmlFor="quantity" >Quantity<span className="color-validation">*</span></label>

                                            <form id="myform" method="POST" class="quantity font-12" action="#">
                                                <input type="button" value="-" class="qtyminus minus" field="quantity" data-type="decrement" data-index={this.state.index} onClick={(e) => this.OnChangeField("QTY", e,this.state.index)} disabled={this.state.cartArr[this.state.index].Qty === 1} />
                                                <input
                                                    type="text"
                                                    name="quantity"
                                                    value={this.state.cartArr[this.state.index].QTY}
                                                    class="qty noborderbin"
                                                    data-type="enterqty"
                                                    maxLength="5"
                                                    onKeyDown={(e) => {
                                                        if (e.key === 'Enter') {
                                                            e.preventDefault();
                                                        }
                                                    }}
                                                    id={"Quantity" + this.state.index}
                                                    disabled={this.state.cartArr[this.state.index].QTY ? true : false}
                                                    data-index={this.state.index}
                                                    onChange={(e) => this.OnChangeField("QTY", e, this.state.index)}
                                                    onBlur={(e) => this.OnChangeField("QTY", e, this.state.index)}
                                                    style={{ cursor: 'default' }}  // This removes the cursor pointer
                                                />
                                                <input type="button" value="+" class="qtyplus plus" field="quantity" data-type="increment" data-index={this.state.index} onClick={(e) => this.OnChangeField("QTY", e, this.state.index)} disabled={this.state.cartArr[this.state.index].QtyAvailable === this.state.cartArr[this.state.index].Qty} />
                                            </form>
                                            {this.state.QtyErrorMsg !== "" ? (
                                                <span className="font-12 font-regular color-validation">{this.state.QtyErrorMsg}</span>
                                            ) : null}
                                        </div>
                                        {this.state.ErrorNew != "" ? <span className=" W-100 errorspan1 text-left mx-3 mt-2" style={{ fontSize: '15px' }}>{this.state.ErrorNew}</span> : null}

                                        {this.state.cartArr.length > 0 && this.state.ErrorNew == "" ? <div className="col-md-12 mt-1 p-0">
                                            <h5 className="font-bold font-16 mb-3">Location details</h5>

                                            {isFromLink ? <div className="table-responsive mt-2 popup-grid-scroll-style custom-displayNew">
                                                <table className="table ZEUS_Grid FOM-grid mobileresponsive-grid mb-0">
                                                    <thead className="">
                                                        <tr>
                                                            <th />
                                                            <th />
                                                            <th>BU</th>
                                                            <th>Qty available</th>
                                                            <th>Qty</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {this.BindEditLocationMob()}

                                                    </tbody>
                                                </table>
                                            </div> :

                                                <div className="table-responsive sm-none popup-grid-scroll-style">
                                                    <table className="table split-delv-table mb-0">
                                                        <thead className="">
                                                            <tr>
                                                                <th />
                                                                <th>BU</th>
                                                                <th>Qty available</th>
                                                                <th>Area</th>
                                                                <th>Aisle</th>
                                                                <th>Row</th>
                                                                <th>Shelf</th>
                                                                <th>Bin</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {this.BindEditLocation()}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            }


                                        </div> : null}
                                    </div>
                                </div>
                                {/*Body ends here*/}
                                {/*button*/}
                                {this.state.isNewPopup == true ? <div className="modal-footer border-0 mt-3 mb-2">
                                    <button className="btn btn-dark-grey font-14 font-medium mr-3 px-4" data-dismiss="modal" onClick={() => this.editCancel()}>Cancel</button>
                                    <button className="btn btn-custom-primary font-14 font-medium px-4" disabled={this.state.ErrorNew ? true : false} onClick={() => this.saveClick()} >Save</button>
                                </div> : null}
                                {/*button*/}
                            </div>
                        </div>
                    </div> : null}
                <div className="modal fade" id="stkissuemixedcart" tabIndex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                    <div className="modal-dialog modal-md modal-dialog-centered" role="document">
                        <div className="modal-content border-0">
                            <div className="modal-header sp-delv-header align-items-center px-4">
                                <h5 className="modal-title" id="exampleModalLongTitle">Confirmation</h5>
                            </div>
                            <div className="modal-body font-15 px-4">
                                Adding this item will clear your stock issue cart due to different truck/rack IDs. Do you want to proceed with this change?
                            </div>
                            <div className="modal-footer border-0 px-4">
                                <button className="btn btn-dark-grey font-14 font-medium mr-3 px-4" type="button" data-dismiss="modal" onClick={this.handleSTKIssueNo}>No</button>
                                <button className="btn btn-custom-primary font-14 font-medium px-4" type="button" onClick={this.handleSTKIssueYes}>Yes</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal" id="QTY-popup" data-backdrop="static" data-keyboard="false">
                    <div className="modal-dialog modal-md custom-popup modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h4 className="modal-title mt-1" />
                                <button type="button" className="btn close-btn" data-dismiss="modal" >
                                    X
                                </button>
                            </div>
                            <div className="modal-body">
                                <div className="row text-center">
                                    <div className="col-md-12 my-4">
                                        <span className="question-mark-icon delete-confirm-icon" />
                                    </div>
                                    <div className="col-12 mb-4">
                                        <label className="confirm-label d-block"><Trans>Confirm</Trans></label>
                                        {this.NAItems()}
                                    </div>
                                    <div className="col-12 mb-4">
                                        <label className="confirm-content d-block"><Trans>Item Quantity not available. To place the order change the quantity or remove the item.</Trans></label>
                                    </div>
                                    <div className="col-md-12 text-center mb-2">
                                        <button className="btn btn-secondary custom-btn-secondary secondary-btn mr-3 px-3" data-dismiss="modal" onClick={() => this.QTYNA("1")}><Trans>Remove these items</Trans></button>
                                        <button className="btn btn-primary custom-btn-primary primary-btn px-5" data-dismiss="modal" onClick={() => this.QTYNA("2")} ><Trans>Apply Change</Trans></button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal orderstatus-popup" id="pdfPreview" data-backdrop="static" data-keyboard="false">
                    <PDFPreviewComponent key={OrderSuccessCOunt} base64URL={this.state.base64URL} PdfPage="1" pdfTitle="Order Status Report" {...this.props} />
                </div>
            </div>


        )
    };
}
export default withTranslation()(STKIssuesCartComponent);